'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _$actualSize$archiv;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*  eslint-disable */

exports.default = (_$actualSize$archiv = {
  ' ': function _(props) {
    return null;
  },
  'actual-size': function actualSize(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 18 18' }, props),
      _react2.default.createElement('polygon', { points: '15 15 15 10 14 10 14 13.29 10.83 10.13 10.13 10.83 13.29 14 10 14 10 15 15 15' }),
      _react2.default.createElement('polygon', { points: '17 17 13 17 13 18 18 18 18 13 17 13 17 17' }),
      _react2.default.createElement('polygon', { points: '13 0 13 1 17 1 17 5 18 5 18 0 13 0' }),
      _react2.default.createElement('polygon', { points: '10.13 7.17 10.83 7.88 14 4.71 14 8 15 8 15 3 10 3 10 4 13.29 4 10.13 7.17' }),
      _react2.default.createElement('polygon', { points: '3 3 3 8 4 8 4 4.71 7.17 7.88 7.88 7.17 4.71 4 8 4 8 3 3 3' }),
      _react2.default.createElement('polygon', { points: '1 1 5 1 5 0 0 0 0 5 1 5 1 1' }),
      _react2.default.createElement('polygon', { points: '1 13 0 13 0 18 5 18 5 17 1 17 1 13' }),
      _react2.default.createElement('polygon', { points: '7.88 10.83 7.17 10.13 4 13.29 4 10 3 10 3 15 8 15 8 14 4.71 14 7.88 10.83' })
    );
  },
  archive: function archive(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 32 28.4' }, props),
      _react2.default.createElement('path', { d: 'M0,1.8V8.9H1.8V30.2H30.2V8.9H32V1.8ZM28.4,28.4H3.6V8.9H28.4ZM30.2,7.1H1.8V3.6H30.2Z',
        transform: 'translate(0 -1.8)' }),
      _react2.default.createElement('path', {
        d: 'M21.3,14.2a1.8,1.8,0,1,1,0,3.6H10.7a1.8,1.8,0,1,1,0-3.6Zm0-1.8H10.7a3.6,3.6,0,0,0,0,7.1H21.3a3.6,3.6,0,1,0,0-7.1Z',
        transform: 'translate(0 -1.8)' })
    );
  },
  barcode: function barcode(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 32 25.14' }, props),
      _react2.default.createElement('path', {
        d: 'M1.13 25.14H0V0h1.13zm1.12 0h-.57V0h.57zm1.68 0h-.55V0h.55zm2.8 0h-.55V0h.55zm2.81 0H8.43V0h1.11zm2.25 0h-.56V0h.56zm1.12 0h-.55V0h.55zm1.13 0h-.56V0H14zm2.8 0h-1.13V0h1.13zm2.8 0h-1.12V0h1.12zm2.25 0h-1.12V0h1.12zm2.25 0H23V0h1.12zm1.68 0H24.7V0h1.12zm3.38 0h-1.68V0h1.68zm1.12 0h-.57V0h.57zm1.68 0h-1.13V0H32z',
        fill: '#676767' })
    );
  },
  database: function database(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 18 18' }, props),
      _react2.default.createElement('path', {
        d: 'M2,2.5v12C2,16.1,5.5,17,9,17s7-.9,7-2.5V2.5C16-.8,2-.8,2,2.5Zm13,8C15,11,12.7,12,9,12s-6-1-6-1.5V7.8A12.8,12.8,0,0,0,9,9a12.8,12.8,0,0,0,6-1.2Zm0-4C15,7,12.7,8,9,8S3,7,3,6.5V3.8A12.8,12.8,0,0,0,9,5a12.8,12.8,0,0,0,6-1.2ZM9,1c3.7,0,6,1,6,1.5S12.7,4,9,4,3,3,3,2.5,5.3,1,9,1ZM9,16c-3.7,0-6-1-6-1.5V11.8A12.8,12.8,0,0,0,9,13a12.8,12.8,0,0,0,6-1.2v2.7C15,15,12.7,16,9,16Z' })
    );
  },
  'database-filled': function databaseFilled(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 18 18' }, props),
      _react2.default.createElement('path', {
        d: 'M16,3c0,.4-.3.8-.9,1.1a7.9,7.9,0,0,1-2.6.9A19,19,0,0,1,9,5.3,19,19,0,0,1,5.5,5a7.9,7.9,0,0,1-2.6-.9C2.3,3.8,2,3.4,2,3V2.3q0-.6.9-1.2A11.5,11.5,0,0,1,5.5.3,19,19,0,0,1,9,0a19,19,0,0,1,3.5.3,11.5,11.5,0,0,1,2.6.8q.9.6.9,1.2Z' }),
      _react2.default.createElement('path', {
        d: 'M16,14.7q0,.6-.9,1.2a11.5,11.5,0,0,1-2.6.8A19,19,0,0,1,9,17a19,19,0,0,1-3.5-.3,11.5,11.5,0,0,1-2.6-.8Q2,15.3,2,14.7V13a8.5,8.5,0,0,0,3,1.2,25,25,0,0,0,4,.3,25,25,0,0,0,4-.3A8.5,8.5,0,0,0,16,13Z' }),
      _react2.default.createElement('path', {
        d: 'M16,10.7q0,.6-.9,1.2a11.5,11.5,0,0,1-2.6.8A19,19,0,0,1,9,13a19,19,0,0,1-3.5-.3,11.5,11.5,0,0,1-2.6-.8Q2,11.3,2,10.7V9a8.5,8.5,0,0,0,3,1.2,25,25,0,0,0,4,.3,25,25,0,0,0,4-.3A8.5,8.5,0,0,0,16,9Z' }),
      _react2.default.createElement('path', {
        d: 'M16,6.7q0,.6-.9,1.2a11.5,11.5,0,0,1-2.6.8A19,19,0,0,1,9,9a19,19,0,0,1-3.5-.3,11.5,11.5,0,0,1-2.6-.8Q2,7.3,2,6.7V5A8.5,8.5,0,0,0,5,6.2a25,25,0,0,0,4,.3,25,25,0,0,0,4-.3A8.5,8.5,0,0,0,16,5Z' })
    );
  },
  'database-download': function databaseDownload(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 18 18' }, props),
      _react2.default.createElement('line', { x1: '0.51', y1: '2.27', x2: '0.51', y2: '13.35', fill: 'none', stroke: '#000', strokeLinecap: 'round',
        strokeMiterlimit: '10' }),
      _react2.default.createElement('line', { x1: '12.51', y1: '2.27', x2: '12.51', y2: '7.44', fill: 'none', stroke: '#000', strokeLinecap: 'round',
        strokeMiterlimit: '10' }),
      _react2.default.createElement('path', { d: 'M.51,6c0,1,2.69,1.84,6,1.84s6-.82,6-1.84', fill: 'none', stroke: '#000', strokeLinecap: 'round',
        strokeMiterlimit: '10' }),
      _react2.default.createElement('ellipse', { cx: '6.51', cy: '2.27', rx: '6', ry: '1.85', fill: 'none', stroke: '#000', strokeLinecap: 'round',
        strokeMiterlimit: '10' }),
      _react2.default.createElement('polyline', { points: '15.28 12.61 12.59 15.3 9.93 12.64', fill: 'none', stroke: '#000', strokeMiterlimit: '10' }),
      _react2.default.createElement('path', { d: 'M12.5,10A3.5,3.5,0,1,1,9,13.5,3.5,3.5,0,0,1,12.5,10m0-1A4.5,4.5,0,1,0,17,13.5,4.49,4.49,0,0,0,12.5,9Z' }),
      _react2.default.createElement('path', { d: 'M12.5,10A3.5,3.5,0,1,1,9,13.5,3.5,3.5,0,0,1,12.5,10m0-1A4.5,4.5,0,1,0,17,13.5,4.49,4.49,0,0,0,12.5,9Z' }),
      _react2.default.createElement('path', { d: 'M.51,9.66c0,1,2.69,1.84,6,1.84', fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeMiterlimit: '10' }),
      _react2.default.createElement('path', { d: 'M12.5,10A3.5,3.5,0,1,1,9,13.5,3.5,3.5,0,0,1,12.5,10m0-1A4.5,4.5,0,1,0,17,13.5,4.49,4.49,0,0,0,12.5,9Z' }),
      _react2.default.createElement('path', { d: 'M.51,13.35c0,1,2.69,1.85,6,1.85', fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeMiterlimit: '10' }),
      _react2.default.createElement('line', { x1: '12.6', y1: '15.31', x2: '12.6', y2: '11.31', fill: 'none', stroke: '#000', strokeMiterlimit: '10' })
    );
  },
  copy: function copy(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 26.7 32' }, props),
      _react2.default.createElement('path', {
        d: 'M22.2,0H8V5.3H2.7V32H24V26.7h5.3V7.1Zm0,2.5,4.6,4.6H22.2Zm0,27.7H4.4V7.1H8V26.7H22.2Zm5.3-5.3H9.8V1.8H20.4V8.9h7.1Z',
        transform: 'translate(-2.7)' })
    );
  },
  'copy-to': function copyTo(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 26.7 32' }, props),
      _react2.default.createElement('path', {
        d: 'M22.2,0H8V5.3H2.7V32H24V26.7h5.3V7.1Zm0,2.5,4.6,4.6H22.2Zm0,27.7H4.4V7.1H8V26.7H22.2Zm5.3-5.3H9.8V1.8H20.4V8.9h7.1Z',
        transform: 'translate(-2.7)' }),
      _react2.default.createElement('polygon', { points: '21.6 16.9 12.5 16.9 16.3 20.7 15.1 22 9.1 16 15.1 10 16.3 11.3 12.5 15.1 21.6 15.1 21.6 16.9' })
    );
  },
  'custom-deploy': function customDeploy(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 18 18' }, props),
      _react2.default.createElement('path', { d: 'M6,13H5V5H16V7h1V0H0V14H6ZM1,1H16V4H1ZM4,13H1V5H4Z' }),
      _react2.default.createElement('path', { d: 'M12.5,14.5a2,2,0,1,1,2-2A2,2,0,0,1,12.5,14.5Zm0-3a1,1,0,1,0,1,1A.9.9,0,0,0,12.5,11.5Z' }),
      _react2.default.createElement('path', {
        d: 'M14.1,18H10.9V16.6a.1.1,0,0,1-.1-.1L9.7,17.6,7.4,15.3l1.1-1.1H7V10.9H8.5L7.4,9.7,9.7,7.4l1.1,1.1h.1V7h3.2V8.4h.1l1.1-1.1,2.3,2.3-1.1,1.1H18v3.2H16.5l1.1,1.1-2.3,2.3-1.1-1.1a.1.1,0,0,1-.1.1Zm-2.2-1h1.2V15.9l.4-.2.6-.2.3-.2.9.8.8-.8-.8-.9.2-.3a1.4,1.4,0,0,0,.2-.6l.2-.4H17V11.9H15.9l-.2-.4a1.4,1.4,0,0,0-.2-.6l-.2-.3.8-.9-.8-.8-.9.8-.3-.2-.6-.2-.4-.2V8H11.9V9.1l-.4.2-.6.2-.3.2-.9-.8-.8.8.8.9-.2.3a1.4,1.4,0,0,0-.2.6l-.2.4H8v1.2H9.1l.2.4a1.4,1.4,0,0,0,.2.6l.2.3-.8.9.8.8.9-.8.3.2.6.2.4.2Z' })
    );
  },
  destroy: function destroy(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 18 18' }, props),
      _react2.default.createElement('path', { d: 'M8,13H5V5H16V9h1V0H0V14H8ZM1,1H16V4H1ZM4,13H1V5H4Z' }),
      _react2.default.createElement('path', {
        d: 'M13.5,10A3.9,3.9,0,0,1,16,11a3.7,3.7,0,0,1,0,5,3.9,3.9,0,0,1-2.5,1A3.9,3.9,0,0,1,11,16a3.7,3.7,0,0,1,0-5,3.9,3.9,0,0,1,2.5-1m0-1a4.4,4.4,0,0,0-3.2,1.3,4.7,4.7,0,0,0,0,6.4A4.4,4.4,0,0,0,13.5,18a4.4,4.4,0,0,0,3.2-1.3,4.7,4.7,0,0,0,0-6.4A4.4,4.4,0,0,0,13.5,9Z' }),
      _react2.default.createElement('polygon', {
        points: '15.6 12.1 14.9 11.4 13.5 12.8 12.1 11.4 11.4 12.1 12.8 13.5 11.4 14.9 12.1 15.6 13.5 14.2 14.9 15.6 15.6 14.9 14.2 13.5 15.6 12.1' })
    );
  },
  deploy: function deploy(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 18 18' }, props),
      _react2.default.createElement('polygon', { points: '14.6 10.4 10.5 6 6.4 10.4 7.1 11.1 10 8 10 17 11 17 11 8 13.9 11.1 14.6 10.4' }),
      _react2.default.createElement('path', { d: 'M0,0V14H8V13H5V5H16v8H13v1h4V0ZM4,13H1V5H4ZM16,4H1V1H16Z' })
    );
  },
  download: function download(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 30.2 32' }, props),
      _react2.default.createElement('polygon', { points: '30.2 21.3 30.2 32 0 32 0 21.3 1.8 21.3 1.8 30.2 28.4 30.2 28.4 21.3 30.2 21.3' }),
      _react2.default.createElement('polygon', { points: '26.4 11.8 15.1 23.1 3.8 11.8 5.1 10.6 14.2 19.7 14.2 0 16 0 16 19.7 25.1 10.6 26.4 11.8' })
    );
  },
  edit: function edit(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 32 32' }, props),
      _react2.default.createElement('path', {
        d: 'M30.7,4.6,27.4,1.3a4.6,4.6,0,0,0-6.5,0L1.6,20.7,0,32l11.3-1.6L30.7,11A4.6,4.6,0,0,0,30.7,4.6ZM10.5,28.7l-4.2.6L2.7,25.8l.6-4.2.5-.5L11,28.2ZM12.2,27,5,19.8,16.2,8.6l7.2,7.2ZM24.7,14.5,17.5,7.3,19.8,5,27,12.2Zm4.7-4.7L28.2,11,21,3.8l1.2-1.2a2.7,2.7,0,0,1,2-.8,2.8,2.8,0,0,1,2,.8l3.2,3.2a2.8,2.8,0,0,1,.8,2A2.7,2.7,0,0,1,29.4,9.8Z' })
    );
  },
  rename: function rename(props) {
    return _react2.default.createElement(
      'svg',
      { viewBox: '0 0 18 16' },
      _react2.default.createElement('polygon', { points: '12 1 14 1 14 0 9 0 9 1 11 1 11 15 9 15 9 16 11 16 12 16 14 16 14 15 12 15 12 1' }),
      _react2.default.createElement('path', { d: 'M9,13H3a2,2,0,0,1-2-2V7A2,2,0,0,1,3,5H9V4H3A2.9,2.9,0,0,0,0,7v4a2.9,2.9,0,0,0,3,3H9Z',
        transform: 'translate(0 -1)' }),
      _react2.default.createElement('path', { d: 'M15,4H14V5h1a2,2,0,0,1,2,2v4a2,2,0,0,1-2,2H14v1h1a2.9,2.9,0,0,0,3-3V7A2.9,2.9,0,0,0,15,4Z',
        transform: 'translate(0 -1)' }),
      _react2.default.createElement('rect', { x: '3', y: '7', width: '6', height: '2' })
    );
  },
  'external-link': function externalLink(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 18 18' }, props),
      _react2.default.createElement('polygon', { points: '9 2 9 3 14.3 3 6.4 10.9 7.1 11.6 15 3.7 15 9 16 9 16 2 9 2' }),
      _react2.default.createElement('polygon', { points: '15 13 15 15 3 15 3 3 5 3 5 2 2 2 2 3 2 15 2 16 16 16 16 15 16 13 15 13' })
    );
  },
  extract: function extract(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 24.9 32' }, props),
      _react2.default.createElement('path', { d: 'M19.6,0H3.6V32H28.4V8.9Zm6.4,8.9H19.6V2.5Zm.7,21.3H5.3V1.8H17.8v8.9h8.9Z', transform: 'translate(-3.6)' }),
      _react2.default.createElement('rect', { x: '5.3', y: '3.6', width: '3.6', height: '1.78' }),
      _react2.default.createElement('rect', { x: '8.9', y: '5.3', width: '3.6', height: '1.78' }),
      _react2.default.createElement('rect', { x: '5.3', y: '7.1', width: '3.6', height: '1.78' }),
      _react2.default.createElement('rect', { x: '8.9', y: '8.9', width: '3.6', height: '1.78' }),
      _react2.default.createElement('rect', { x: '5.3', y: '10.7', width: '3.6', height: '1.78' }),
      _react2.default.createElement('rect', { x: '8.9', y: '12.4', width: '3.6', height: '1.78' }),
      _react2.default.createElement('rect', { x: '8.9', y: '16', width: '3.6', height: '1.78' }),
      _react2.default.createElement('rect', { x: '5.3', y: '14.2', width: '3.6', height: '1.78' }),
      _react2.default.createElement('path', {
        d: 'M12.4,19.6a1.8,1.8,0,1,1-1.8,1.8,1.8,1.8,0,0,1,1.8-1.8m0-1.8A3.6,3.6,0,1,0,16,21.3a3.6,3.6,0,0,0-3.6-3.6Z',
        transform: 'translate(-3.6)' })
    );
  },
  move: function move(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 32 32' }, props),
      _react2.default.createElement('polygon', { points: '16.9 18.8 16.9 28.4 21 24.4 22.3 25.7 16 32 9.7 25.7 11 24.4 15.1 28.4 15.1 18.8 16.9 18.8' }),
      _react2.default.createElement('polygon', { points: '15.1 13.2 15.1 3.6 11 7.6 9.7 6.3 16 0 22.3 6.3 21 7.6 16.9 3.6 16.9 13.2 15.1 13.2' }),
      _react2.default.createElement('polygon', { points: '18.8 15.1 28.4 15.1 24.4 11 25.7 9.7 32 16 25.7 22.3 24.4 21 28.4 16.9 18.8 16.9 18.8 15.1' }),
      _react2.default.createElement('polygon', { points: '13.2 16.9 3.6 16.9 7.6 21 6.3 22.3 0 16 6.3 9.7 7.6 11 3.6 15.1 13.2 15.1 13.2 16.9' })
    );
  },
  'move-to': function moveTo(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 18 16' }, props),
      _react2.default.createElement('polygon', {
        points: '8 11 1 11 1 1 5.9 1 9.2 3.5 9.4 3.7 9.8 3.7 15 3.7 15 6 16 6 16 2.7 9.8 2.7 6.2 0 0 0 0 12 8 12 8 11' }),
      _react2.default.createElement('path', { d: 'M13.5,8A3.5,3.5,0,1,1,10,11.5,3.5,3.5,0,0,1,13.5,8m0-1A4.5,4.5,0,1,0,18,11.5,4.5,4.5,0,0,0,13.5,7Z' }),
      _react2.default.createElement('polygon', { points: '11 11 14.3 11 13.1 9.9 13.9 9.1 16.2 11.5 13.9 13.9 13.1 13.1 14.3 12 11 12 11 11' })
    );
  },
  file: function file(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ i: true, viewBox: '0 0 64 64' }, props),
      _react2.default.createElement('path', { d: 'M53.2,64H10.8A3.9,3.9,0,0,1,7,60V4a3.9,3.9,0,0,1,3.8-4H39L57,18V60A3.9,3.9,0,0,1,53.2,64Z' }),
      _react2.default.createElement('path', { d: 'M57,18H42.9A3.8,3.8,0,0,1,39,14.1V0Z', fill: '#dddcdc' })
    );
  },
  'file-csv': function fileCsv(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 18 18' }, props),
      _react2.default.createElement('path', { d: 'M11 0H2v18h14V5zm3.59 5H11V1.41zM15 17H3V1h7v5h5z' }),
      _react2.default.createElement('path', { d: 'M5 8h8v1H5zm0 2h8v1H5zm0 2h8v1H5zm0 2h8v1H5zM4 8h1v7H4zm9 0h1v7h-1z' }),
      _react2.default.createElement('path', { d: 'M7 8h1v7H7zm3 0h1v7h-1z' })
    );
  },
  'file-drag': function fileDrag(props) {
    return _react2.default.createElement(
      'svg',
      { viewBox: '0 0 64 64' },
      _react2.default.createElement('path', { d: 'M37,47.6a1,1,0,0,1-1-1v-1a1,1,0,1,1,2,0v1A1,1,0,0,1,37,47.6Z' }),
      _react2.default.createElement('path', {
        d: 'M28,63H25.9a1,1,0,0,1,0-2H28a1,1,0,0,1,0,2Zm-8.2,0H17.7a1,1,0,0,1,0-2h2.1a1,1,0,0,1,0,2Zm-8.3,0h-2a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Zm22.6-.2a1,1,0,0,1-.9-.7,1,1,0,0,1,.6-1.3,5.7,5.7,0,0,0,1.3-.8,1,1,0,0,1,1.5,1.3,5.5,5.5,0,0,1-2.1,1.4ZM3.4,62.6H3a6.4,6.4,0,0,1-2-1.6,1.1,1.1,0,0,1,.2-1.4.9.9,0,0,1,1.4.2,5.8,5.8,0,0,0,1.2,1A1,1,0,0,1,4.3,62,1.1,1.1,0,0,1,3.4,62.6ZM37,55.8a1,1,0,0,1-1-1V52.7a1,1,0,0,1,2,0v2.1A1,1,0,0,1,37,55.8ZM1,55.3a1,1,0,0,1-1-1V52.2a1,1,0,0,1,2,0v2.1A1,1,0,0,1,1,55.3Zm0-8.2a1,1,0,0,1-1-1V44a.9.9,0,0,1,1-1,.9.9,0,0,1,1,1v2.1A1,1,0,0,1,1,47.1Zm0-8.3a.9.9,0,0,1-1-1v-2a.9.9,0,0,1,1-1,.9.9,0,0,1,1,1v2A.9.9,0,0,1,1,38.8Zm0-8.2a.9.9,0,0,1-1-1v-2a.9.9,0,0,1,1-1,.9.9,0,0,1,1,1v2A.9.9,0,0,1,1,30.6Zm.1-8.2H.9a1,1,0,0,1-.8-1.2,7,7,0,0,1,1.1-2.3,1,1,0,0,1,1.4-.1,1,1,0,0,1,.1,1.4,3.5,3.5,0,0,0-.6,1.4A1,1,0,0,1,1.1,22.4ZM9.7,19h-2a1,1,0,1,1,0-2h2a1,1,0,0,1,0,2Z' }),
      _react2.default.createElement('path', { d: 'M16.9,19h-1a1,1,0,1,1,0-2h1a1,1,0,0,1,0,2Z' }),
      _react2.default.createElement('path', {
        d: 'M46.9,54.6h-.5a2.1,2.1,0,0,1-1.5-1.4L38.1,32.3a2.9,2.9,0,0,1,0-1.3,2.1,2.1,0,0,1,2.7-1.4h0l21.7,6.5a1.9,1.9,0,0,1,1.4,1.5,2.1,2.1,0,0,1-.6,2.1l-4,3.8L62.8,47a2.2,2.2,0,0,1,0,3l-3.7,3.7a2.2,2.2,0,0,1-3,0l-3.6-3.6L48.4,54A2,2,0,0,1,46.9,54.6ZM40.1,31.5a.1.1,0,0,0-.1.1l6.8,20.9a.1.1,0,0,0,.1.1c.1,0,.1,0,.1-.1l5.5-5.2,5,5h.2l3.7-3.7h0l-4.9-5L62,38.2h0a.1.1,0,0,0-.1-.1L40.2,31.5Z' }),
      _react2.default.createElement('path', {
        d: 'M53.8,11.3,43.6,1.2A3.6,3.6,0,0,0,40.8,0H21a4,4,0,0,0-4,4V42a4,4,0,0,0,4,4H42.6l-.7-2H21a2,2,0,0,1-2-2V4a2,2,0,0,1,2-2H40.2v9a4,4,0,0,0,4,4H53V33.2l2,.6V14.2A4,4,0,0,0,53.8,11.3ZM42.2,11V2.6h0L52.4,12.7l.2.3H44.2A2,2,0,0,1,42.2,11Z' })
    );
  },
  'file-excel': function fileExcel(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 18 18' }, props),
      _react2.default.createElement('path', { d: 'M11 0H2v18h14V5zm3.59 5H11V1.41zM15 17H3V1h7v5h5z' }),
      _react2.default.createElement('path', {
        d: 'M6 14.05V15h2.48v-.95h-.67l.92-1.43.09-.15a.54.54 0 0 1 .07-.12.18.18 0 0 0 0 .09.43.43 0 0 0 0 .07l.06.07.05.08 1 1.43h-.59V15H12v-.95h-.6l-1.71-2.43 1.74-2.52H12v-1H9.54v1h.66l-.92 1.42-.09.15a.49.49 0 0 0-.08.12.31.31 0 0 0 0-.09 1.27 1.27 0 0 0-.16-.2L7.93 9.1h.68v-1H6v1h.6l1.69 2.43-1.71 2.52z' })
    );
  },
  'file-new': function fileNew(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 26.2 32' }, props),
      _react2.default.createElement('path', { d: 'M16,0H2.9V26.2H14.6a6.1,6.1,0,0,1,0-1.5H4.4V1.5H14.5V8.7h7.3v8.8h1.5V7.3Zm0,7.3V2.1l5.2,5.2Z',
        transform: 'translate(-2.9)' }),
      _react2.default.createElement('rect', { x: '4.4', y: '11.6', width: '11.6', height: '1.45' }),
      _react2.default.createElement('rect', { x: '4.4', y: '14.5', width: '11.6', height: '1.45' }),
      _react2.default.createElement('rect', { x: '4.4', y: '17.5', width: '11.6', height: '1.45' }),
      _react2.default.createElement('rect', { x: '4.4', y: '20.4', width: '7.3', height: '1.45' }),
      _react2.default.createElement('path', {
        d: 'M22.5,18.9a6.5,6.5,0,1,0,6.5,6.5A6.6,6.6,0,0,0,22.5,18.9Zm0,11.6a5.1,5.1,0,1,1,5.1-5.1A5.1,5.1,0,0,1,22.5,30.5Z',
        transform: 'translate(-2.9)' }),
      _react2.default.createElement('polygon', {
        points: '23.3 24.7 23.3 26.2 20.4 26.2 20.4 29.1 18.9 29.1 18.9 26.2 16 26.2 16 24.7 18.9 24.7 18.9 21.8 20.4 21.8 20.4 24.7 23.3 24.7' })
    );
  },
  'file-outlined': function fileOutlined(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 18 18' }, props),
      _react2.default.createElement('path', { d: 'M11,0H2L2,18H16L16,5Zm3.58,5L11,5V1.43ZM15,17H3V1h7V6h5Z' }),
      _react2.default.createElement('rect', { x: '5', y: '9', width: '8', height: '1' }),
      _react2.default.createElement('rect', { x: '5', y: '11', width: '8', height: '1' }),
      _react2.default.createElement('rect', { x: '5', y: '13', width: '8', height: '1' })
    );
  },
  'file-pdf': function filePdf(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 18 18' }, props),
      _react2.default.createElement('path', { d: 'M11 0H2v18h14V5zm3.59 5H11V1.41zM15 17H3V1h7v5h5z' }),
      _react2.default.createElement('path', {
        d: 'M10.37 12l-.17-.2a10.52 10.52 0 0 1-1.08-1.48 11.31 11.31 0 0 0 .27-2.07v-.1c0-.62 0-1.67-.87-1.86a1 1 0 0 0-.78.16 1.15 1.15 0 0 0-.44.75 5.81 5.81 0 0 0 1 3.25 12.28 12.28 0 0 1-.71 2.12 8 8 0 0 0-1.95 1.08c-1.09.78-1 1.37-.83 1.64a.85.85 0 0 0 .76.4A1.2 1.2 0 0 0 6 15.6a4.84 4.84 0 0 0 2.11-2.38 8.23 8.23 0 0 1 1.92-.4 3.63 3.63 0 0 0 2.12 1.25 1 1 0 0 0 1.12-.77c0-.42-.25-1-1-1.13a7.79 7.79 0 0 0-1.89-.17zM5.7 14.89a.37.37 0 0 1-.22 0 1.61 1.61 0 0 1 .6-.62 7.21 7.21 0 0 1 .85-.55 3.15 3.15 0 0 1-1.23 1.17zm2.38-7.57a.33.33 0 0 1 .12-.21.2.2 0 0 1 .11 0c.25 0 .25.54.24 1.07v.11a8.89 8.89 0 0 1-.08 1 3.91 3.91 0 0 1-.44-1.89zm.46 5c.12-.3.22-.61.31-.91.18.26.37.51.56.74-.28 0-.57.1-.87.17zm3.55.66c.33.07.43.23.43.26s-.09.1-.32.08a1.87 1.87 0 0 1-1-.46 5.4 5.4 0 0 1 .86.12z' })
    );
  },
  'file-upload': function fileUpload(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 24.9 32' }, props),
      _react2.default.createElement('path', { d: 'M19.6,0H3.6V32H28.4V8.9Zm0,2.5,6.4,6.4H19.6Zm7.1,27.7H5.3V1.8H17.8v8.9h8.9Z',
        transform: 'translate(-3.6)' }),
      _react2.default.createElement('polygon', {
        points: '18.4 20.2 17.1 21.4 13.3 17.6 13.3 26.7 11.6 26.7 11.6 17.6 7.7 21.4 6.5 20.2 12.4 14.2 18.4 20.2' })
    );
  },
  folder: function folder(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 32 24' }, props),
      _react2.default.createElement('polygon', { points: '14 4 10.5 0 0 0 0 24 32 24 32 4 14 4' })
    );
  },
  'folder-outlined': function folderOutlined(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 64 64' }, props),
      _react2.default.createElement('path', {
        d: 'M59,57H5a5.1,5.1,0,0,1-5-5V12A5.1,5.1,0,0,1,5,7H23.8a5.7,5.7,0,0,1,3,1l11.6,8.7a3,3,0,0,0,1.8.6H59a5,5,0,0,1,5,5V52A5.1,5.1,0,0,1,59,57ZM5,9a3.1,3.1,0,0,0-3,3V52a3.1,3.1,0,0,0,3,3H59a3.1,3.1,0,0,0,3-3V22.3a3,3,0,0,0-3-3H40.2a5.7,5.7,0,0,1-3-1L25.6,9.6A3,3,0,0,0,23.8,9Z' })
    );
  },
  'folder-new': function folderNew(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 32 27.6' }, props),
      _react2.default.createElement('path', { d: 'M16,6.5,10.2,2.2H0V24H17.5a6.1,6.1,0,0,1,0-1.5H1.5V3.6H9.7l5.4,4.1.4.3h9.2v7.3h1.5V6.5Z',
        transform: 'translate(0 -2.2)' }),
      _react2.default.createElement('path', {
        d: 'M25.5,16.7A6.5,6.5,0,1,0,32,23.3,6.5,6.5,0,0,0,25.5,16.7Zm0,11.6a5.1,5.1,0,1,1,5.1-5.1A5.1,5.1,0,0,1,25.5,28.4Z',
        transform: 'translate(0 -2.2)' }),
      _react2.default.createElement('polygon', {
        points: '29.1 20.4 29.1 21.8 26.2 21.8 26.2 24.7 24.7 24.7 24.7 21.8 21.8 21.8 21.8 20.4 24.7 20.4 24.7 17.5 26.2 17.5 26.2 20.4 29.1 20.4' })
    );
  },
  'folder-upload': function folderUpload(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 32 26.7' }, props),
      _react2.default.createElement('path', { d: 'M19.6,8,12.4,2.7H0V29.3H32V8ZM30.2,27.6H1.8V4.4H11.9l6.6,5,.5.4H30.2Z', transform: 'translate(0 -2.7)' }),
      _react2.default.createElement('polygon', { points: '22 14.8 20.7 16.1 16.9 12.3 16.9 21.3 15.1 21.3 15.1 12.3 11.3 16.1 10 14.8 16 8.9 22 14.8' })
    );
  },
  glob: function glob(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 18 18' }, props),
      _react2.default.createElement('path', {
        d: 'M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0Zm7.41,6H12.77A11.05,11.05,0,0,0,11,1.27,8,8,0,0,1,16.41,6ZM12,9a18,18,0,0,1-.11,2H6.11a18.24,18.24,0,0,1,0-4h5.78A18,18,0,0,1,12,9ZM9,17c-.95,0-2.23-1.88-2.75-5h5.5C11.23,15.12,10,17,9,17ZM6.25,6C6.77,2.88,8.05,1,9,1s2.23,1.88,2.75,5ZM7,1.27A11.05,11.05,0,0,0,5.23,6H1.59A8,8,0,0,1,7,1.27ZM1.26,7H5.1C5,7.64,5,8.31,5,9s0,1.36.1,2H1.26A8.24,8.24,0,0,1,1,9,8.24,8.24,0,0,1,1.26,7Zm.33,5H5.23A11.05,11.05,0,0,0,7,16.73,8,8,0,0,1,1.59,12ZM11,16.73A11.05,11.05,0,0,0,12.77,12h3.64A8,8,0,0,1,11,16.73ZM16.74,11H12.9c.06-.64.1-1.31.1-2s0-1.36-.1-2h3.84A8.24,8.24,0,0,1,17,9,8.24,8.24,0,0,1,16.74,11Z' })
    );
  },
  key: function key(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 17.8 32' }, props),
      _react2.default.createElement('path', {
        d: 'M16,1.8a7.1,7.1,0,0,1,7.1,7.1,7,7,0,0,1-2.8,5.7l-.7.5v2l-1.3,1.3L17,19.6l1.3,1.3,1.3,1.3v.3l-1.3,1.3L17,24.9l1.3,1.3,1.3,1.3h0L16,29.9l-3.6-2.4V15.1l-.7-.5A7,7,0,0,1,8.9,8.9,7.1,7.1,0,0,1,16,1.8M16,0a8.9,8.9,0,0,0-5.3,16V28.4L16,32l5.3-3.6V26.7l-1.8-1.8,1.8-1.8V21.3l-1.8-1.8,1.8-1.8V16A8.9,8.9,0,0,0,16,0Z',
        transform: 'translate(-7.1)' }),
      _react2.default.createElement('path', { d: 'M16,5.3a1.8,1.8,0,1,1-1.8,1.8A1.8,1.8,0,0,1,16,5.3m0-1.8a3.6,3.6,0,1,0,3.6,3.6A3.6,3.6,0,0,0,16,3.6Z',
        transform: 'translate(-7.1)' })
    );
  },
  login: function login(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 18 18' }, props),
      _react2.default.createElement('polygon', { points: '9.6 4.4 8.9 5.1 12 8 1 8 1 9 12 9 8.9 11.9 9.6 12.6 14 8.5 9.6 4.4' }),
      _react2.default.createElement('polygon', { points: '17 0 5 0 5 1 5 4 6 4 6 1 17 1 17 16 6 16 6 13 5 13 5 16 5 17 17 17 18 17 18 16 18 1 18 0 17 0' })
    );
  },
  replicate: function replicate(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 18 18' }, props),
      _react2.default.createElement('path', { d: 'M6,7V17H18V7Zm1,9V11H9v5Zm10,0H10V11h7Zm0-6H7V8H17Z' }),
      _react2.default.createElement('path', { d: 'M5,10H4V5h7V6h1V1H0V11H5ZM1,2H11V4H1Zm2,8H1V5H3Z' })
    );
  },
  save: function save(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 32 32' }, props),
      _react2.default.createElement('path', { d: 'M26.7,0H0V32H32V5.3ZM8.9,1.8H23.1V8.9H8.9ZM30.2,30.2H1.8V1.8H7.1v8.9H24.9V1.8h1l4.3,4.3Z' }),
      _react2.default.createElement('rect', { x: '19.6', y: '3.6', width: '1.8', height: '3.56' }),
      _react2.default.createElement('path', { d: 'M16,16a3.6,3.6,0,1,1-3.6,3.6A3.6,3.6,0,0,1,16,16Zm0-1.8a5.3,5.3,0,1,0,5.3,5.3A5.3,5.3,0,0,0,16,14.2Z' })
    );
  },
  search: function search(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 32 32' }, props),
      _react2.default.createElement('path', {
        d: 'M21.2,19.7A12,12,0,1,0,12,24a11.8,11.8,0,0,0,7.7-2.8L30.6,32,32,30.6ZM12,22a10,10,0,1,1,7.1-2.9A10,10,0,0,1,12,22Z',
        transform: 'translate(0 0)'
      })
    );
  },
  sizer: function sizer(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 32 32' }, props),
      _react2.default.createElement('path', {
        d: 'M26.7,21.3a5.3,5.3,0,0,0-5,3.5L17,16.1,25.6,0h-2L16,14.2,8.5,0h-2L15,16.1l-4.7,8.8a5.3,5.3,0,1,0-5,7.1,5.5,5.5,0,0,0,2.8-.8,5.6,5.6,0,0,0,1.8-2h0L16,18l5.8,11,.2.5v.2a6,6,0,0,0,1.6,1.5,5.5,5.5,0,0,0,2.8.8,5.3,5.3,0,0,0,0-10.7Zm-18.2,7h0a3.6,3.6,0,1,1,.4-1.7A3.5,3.5,0,0,1,8.5,28.3Zm18.2,1.9a3.6,3.6,0,0,1-3.1-1.8h0a3.3,3.3,0,0,1-.4-1.7,3.6,3.6,0,1,1,3.6,3.6Z' })
    );
  },
  shield: function shield(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 27 33' }, props),
      _react2.default.createElement('path', {
        d: 'M26.96 8.41V5.8a.89.89 0 0 0-.25-.63.87.87 0 0 0-.64-.27c-5 0-8.74-1.48-11.9-4.64a.82.82 0 0 0-.63-.26.92.92 0 0 0-.63.26C9.75 3.42 5.97 4.9 1.01 4.9a.9.9 0 0 0-.9.9v2.6c-.16 8.8-.35 19.75 13.14 24.57h.61c13.46-4.81 13.26-15.77 13.1-24.56zM13.5 31.17C1.5 26.72 1.67 16.58 1.82 8.41V6.69A17.34 17.34 0 0 0 13.5 2.18a17.09 17.09 0 0 0 11.64 4.51v1.73c.19 8.16.36 18.3-11.64 22.75z' }),
      _react2.default.createElement('path', {
        d: 'M19.85 11.87a1.11 1.11 0 0 0-.79.31l-6.41 6.23-2.67-3a.84.84 0 0 0-.54-.22 1 1 0 0 0-.85.32 1.13 1.13 0 0 0-.31.86 1.09 1.09 0 0 0 .36.73l3.2 3.7a1.06 1.06 0 0 0 .79.33 1 1 0 0 0 .75-.32l7.2-7a1.11 1.11 0 0 0-.72-1.92z' })
    );
  },
  replace: function replace(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 32 32' }, props),
      _react2.default.createElement('path', {
        d: 'M21.3,2.4H9.2V6.9H4.7V29.6H22.8V25h4.5V8.4Zm0,2.1,3.9,3.9H21.3Zm0,23.5H6.2V8.4h3V25H21.3Zm4.5-4.5H10.7V3.9h9.1v6h6Z' }),
      _react2.default.createElement('polygon', {
        points: '32 24.2 32 29.6 27.9 29.6 29.3 30.9 28.2 32 26.1 29.9 25 28.8 26.1 27.7 28.2 25.6 29.3 26.7 27.9 28.1 30.5 28.1 30.5 24.2 32 24.2' }),
      _react2.default.createElement('polygon', {
        points: '7 3.2 5.9 4.3 3.8 6.4 2.7 5.3 4.1 4 1.5 4 1.5 7.8 0 7.8 0 2.5 4.1 2.5 2.7 1.1 3.8 0 5.9 2.1 7 3.2' })
    );
  },
  'tabs-close': function tabsClose(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 32 32' }, props),
      _react2.default.createElement('polygon', {
        points: '17.2 17.8 22.8 23.4 22.2 24 21.6 24.6 16 19 10.4 24.6 9.2 23.4 14.8 17.8 9.2 12.2 9.8 11.6 10.4 10.9 16 16.5 21.6 10.9 22.8 12.2 17.2 17.8' }),
      _react2.default.createElement('path', {
        d: 'M28.4,0H21.3V3.6L17.8,0H10.7V3.6L7.1,0H0V32H32V3.6ZM23.1,1.8h4.6l1.8,1.8H23.1Zm-10.7,0H17l1.8,1.8H12.4ZM1.8,1.8H6.4L8.2,3.6H1.8ZM30.2,30.2H1.8V5.3H30.2Z' })
    );
  },
  trash: function trash(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 24.9 32' }, props),
      _react2.default.createElement('rect', { x: '14.2', y: '10.7', width: '1.8', height: '16' }),
      _react2.default.createElement('rect', { x: '8.9', y: '10.7', width: '1.8', height: '16' }),
      _react2.default.createElement('path', {
        d: 'M23.1,5.3V3.6A3.6,3.6,0,0,0,19.6,0H12.4A3.6,3.6,0,0,0,8.9,3.6V5.3H3.6V7.1H5.3V28.4A3.6,3.6,0,0,0,8.9,32H23.1a3.6,3.6,0,0,0,3.6-3.6V7.1h1.8V5.3ZM10.7,3.6a1.8,1.8,0,0,1,1.8-1.8h7.1a1.8,1.8,0,0,1,1.8,1.8V5.3H10.7ZM24.9,28.4a1.8,1.8,0,0,1-1.8,1.8H8.9a1.8,1.8,0,0,1-1.8-1.8V7.1H24.9Z',
        transform: 'translate(-3.6)' })
    );
  },
  paste: function paste(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 24.9 32' }, props),
      _react2.default.createElement('rect', { x: '5.3', y: '14.2', width: '14.2', height: '1.78' }),
      _react2.default.createElement('path', { d: 'M23.1,3.6V1.8H19.6V0H12.4V1.8H8.9V3.6H3.6V32H28.4V3.6Zm3.6,26.7H5.3V5.3H8.9V7.1H23.1V5.3h3.6Z',
        transform: 'translate(-3.6)' }),
      _react2.default.createElement('rect', { x: '5.3', y: '17.8', width: '14.2', height: '1.78' }),
      _react2.default.createElement('rect', { x: '5.3', y: '21.3', width: '14.2', height: '1.78' }),
      _react2.default.createElement('rect', { x: '5.3', y: '24.9', width: '14.2', height: '1.78' })
    );
  },
  'add-user': function addUser(props) {
    return _react2.default.createElement(
      'svg',
      { viewBox: '0 0 18 18' },
      _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('path', { d: 'M6.5,0C4.6,0,3,1.6,3,3.5C3,5.4,4.6,7,6.5,7S10,5.4,10,3.5C10,1.6,8.4,0,6.5,0L6.5,0z M6.5,6C5.1,6,4,4.9,4,3.5 C4,2.1,5.1,1,6.5,1S9,2.1,9,3.5C9,4.9,7.9,6,6.5,6L6.5,6z' })
      ),
      _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('path', { d: 'M8,7H6.5H5c-2.2,0-4,1.8-4,4v3.7C1,14.9,1.1,15,1.3,15h5.9c-0.1-0.3-0.2-0.7-0.2-1H2v-3c0-1.7,1.3-3,3-3h3 c0.7,0,1.4,0.3,1.9,0.7c0.3-0.2,0.7-0.3,1-0.4C10.2,7.5,9.1,7,8,7L8,7z' })
      ),
      _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('path', { d: 'M12.5,10c1.9,0,3.5,1.6,3.5,3.5S14.4,17,12.5,17S9,15.4,9,13.5S10.6,10,12.5,10 M12.5,9C10,9,8,11,8,13.5s2,4.5,4.5,4.5 s4.5-2,4.5-4.5S15,9,12.5,9L12.5,9z' })
      ),
      _react2.default.createElement('polygon', { points: '13,13 13,11 12,11 12,13 10,13 10,14 12,14 12,16 13,16 13,14 15,14 15,13 ' })
    );
  },
  'arrow-back': function arrowBack(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 32 23.7' }, props),
      _react2.default.createElement('polygon', { points: '4 10.8 13.3 1.5 11.8 0 0 11.8 11.8 23.7 13.3 22.2 4 12.9 32 12.9 32 10.8 4 10.8' })
    );
  },
  // TODO default
  'arrow-left-thin': function arrowLeftThin(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 17 32' }, props),
      _react2.default.createElement('path', { d: 'M15.5,8l8-8,.5.5.5.5L22,3.5l-7.4,7.4c-2.7,2.8-4.9,5.1-5,5.1s3.4,3.4,7.5,7.5L24.5,31l-.5.5-.5.5-8-8-8-8Z',
        transform: 'translate(-7.5)' })
    );
  },
  'arrow-down': function arrowDown(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 32 32' }, props),
      _react2.default.createElement('polygon', { points: '16,26 0,12.4 0,6 16,19.6 32,6 32,12.4 ' })
    );
  },
  'arrow-right': function arrowRight(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 18.8 30' }, props),
      _react2.default.createElement('polygon', { points: '18.8 15 6 30 0 30 12.8 15 0 0 6 0 18.8 15' })
    );
  },
  'arrow-right-thin': function arrowRightThin(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 95.4 179.5' }, props),
      _react2.default.createElement('path', {
        d: 'M98.9,134.7,54,179.5l-2.9-2.9-2.9-2.9L62,159.9l41.6-41.8c15.3-15.4,27.9-28.1,28-28.4S112.9,70.5,90,47.6L48.2,5.8l2.9-2.9L54,0,98.8,44.8c24.6,24.6,44.8,44.9,44.8,45S123.5,110.1,98.9,134.7Z',
        transform: 'translate(-48.2 0)' })
    );
  },
  'arrow-up': function arrowUp(props) {
    return _react2.default.createElement(
      'svg',
      _extends({ viewBox: '0 0 32 20' }, props),
      _react2.default.createElement('polygon', { points: '16 0 32 13.6 32 20 16 6.4 0 20 0 13.6 16 0' })
    );
  }
}, _defineProperty(_$actualSize$archiv, 'generic-calendar', function genericCalendar(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 18 18' }, props),
    _react2.default.createElement('path', { d: 'M14,3V1H11V3H6V1H3V3H1V17H16V3ZM12,2h1V4H12V2ZM4,2H5V4H4V2ZM15,16H2V6H15Z' }),
    _react2.default.createElement('rect', { x: '6', y: '7', width: '2', height: '2' }),
    _react2.default.createElement('rect', { x: '9', y: '7', width: '2', height: '2' }),
    _react2.default.createElement('rect', { x: '12', y: '7', width: '2', height: '2' }),
    _react2.default.createElement('rect', { x: '3', y: '10', width: '2', height: '2' }),
    _react2.default.createElement('rect', { x: '6', y: '10', width: '2', height: '2' }),
    _react2.default.createElement('rect', { x: '9', y: '10', width: '2', height: '2' }),
    _react2.default.createElement('rect', { x: '12', y: '10', width: '2', height: '2' }),
    _react2.default.createElement('rect', { x: '3', y: '13', width: '2', height: '2' }),
    _react2.default.createElement('rect', { x: '6', y: '13', width: '2', height: '2' }),
    _react2.default.createElement('rect', { x: '9', y: '13', width: '2', height: '2' })
  );
}), _defineProperty(_$actualSize$archiv, 'generic-clock', function genericClock(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 18 18' }, props),
    _react2.default.createElement('path', { d: 'M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0ZM9,17a8,8,0,1,1,8-8,8,8,0,0,1-8,8Z' }),
    _react2.default.createElement('polygon', { points: '9 3 8 3 8 9 8 10 9 10 14 10 14 9 9 9 9 3 9 3' })
  );
}), _defineProperty(_$actualSize$archiv, 'check', function check(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 32 32' }, props),
    _react2.default.createElement('polygon', { className: 'st0', points: '27,3.7 12.4,18 5,10.5 0,15.5 10,25.8 12.4,28.3 32,8.7 ' })
  );
}), _defineProperty(_$actualSize$archiv, 'check-square', function checkSquare(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 32 32' }, props),
    _react2.default.createElement('rect', { x: '6', y: '6', width: '20', height: '20' })
  );
}), _defineProperty(_$actualSize$archiv, 'chevron-down', function chevronDown(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 32 29.55' }, props),
    _react2.default.createElement('polygon', { points: '1.68 11.87 16 26.19 30.32 11.87 32 13.55 16 29.55 0 13.55 1.68 11.87' }),
    _react2.default.createElement('polygon', { points: '1.68 0 16 14.32 30.32 0 32 1.68 16 17.68 0 1.68 1.68 0' })
  );
}), _defineProperty(_$actualSize$archiv, 'chevron-up', function chevronUp(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 32 29.55' }, props),
    _react2.default.createElement('polygon', { points: '30.32 17.68 16 3.36 1.68 17.68 0 16 16 0 32 16 30.32 17.68' }),
    _react2.default.createElement('polygon', { points: '30.32 29.55 16 15.23 1.68 29.55 0 27.87 16 11.87 32 27.87 30.32 29.55' })
  );
}), _defineProperty(_$actualSize$archiv, 'chevron-right', function chevronRight(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 20 22' }, props),
    _react2.default.createElement('polygon', { points: '7.84 20.84 17.69 11 7.84 1.16 9 0 20 11 9 22 7.84 20.84' }),
    _react2.default.createElement('polygon', { points: '0 20.84 9.85 11 0 1.16 1.16 0 12.15 11 1.16 22 0 20.84' })
  );
}), _defineProperty(_$actualSize$archiv, 'circle-minus', function circleMinus(props) {
  return _react2.default.createElement(
    'svg',
    _extends({}, props, { viewBox: '0 0 32 32' }),
    _react2.default.createElement('path', { d: 'M16,32A16,16,0,1,1,32,16,16,16,0,0,1,16,32ZM16,1A15,15,0,1,0,31,16,15,15,0,0,0,16,1Z' }),
    _react2.default.createElement('rect', { x: '10', y: '15.5', width: '12', height: '1' })
  );
}), _defineProperty(_$actualSize$archiv, 'circle-plus', function circlePlus(props) {
  return _react2.default.createElement(
    'svg',
    _extends({}, props, { viewBox: '0 0 32 32' }),
    _react2.default.createElement('polygon', {
      points: '23.5 15.5 23.5 16.5 16.5 16.5 16.5 23.5 15.5 23.5 15.5 16.5 8.5 16.5 8.5 15.5 15.5 15.5 15.5 8.5 16.5 8.5 16.5 15.5 23.5 15.5' }),
    _react2.default.createElement('path', { d: 'M16,32A16,16,0,1,1,32,16,16,16,0,0,1,16,32ZM16,1A15,15,0,1,0,31,16,15,15,0,0,0,16,1Z' })
  );
}), _defineProperty(_$actualSize$archiv, 'credit-card', function creditCard(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 32 24' }, props),
    _react2.default.createElement('path', {
      d: 'M28,0H4A4,4,0,0,0,0,4V20a4,4,0,0,0,4,4H28a4,4,0,0,0,4-4V4A4,4,0,0,0,28,0Zm2,20a2,2,0,0,1-2,2H4a2,2,0,0,1-2-2V10H30ZM30,6H2V4A2,2,0,0,1,4,2H28a2,2,0,0,1,2,2Z'
    }),
    _react2.default.createElement('rect', { x: '4', y: '12', width: '12', height: '2' }),
    _react2.default.createElement('rect', { x: '4', y: '16', width: '4', height: '2' }),
    _react2.default.createElement('rect', { x: '22', y: '12', width: '6', height: '4' })
  );
}), _defineProperty(_$actualSize$archiv, 'cross', function cross(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 32 32' }, props),
    _react2.default.createElement('polygon', {
      points: '20.7,16.2 32,27.5 27.5,32 16.2,20.7 4.5,32 0,27.5 11.3,16.2 0,4.5 4.5,0 16.2,11.3 27.5,0 32,4.5 '
    })
  );
}), _defineProperty(_$actualSize$archiv, 'dashboard', function dashboard(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 14 14' }, props),
    _react2.default.createElement('path', { d: 'M2,16H8V10H2Zm1-5H7v4H3Z', transform: 'translate(-2 -2)' }),
    _react2.default.createElement('path', { d: 'M2,8H8V2H2ZM3,3H7V7H3Z', transform: 'translate(-2 -2)' }),
    _react2.default.createElement('path', { d: 'M10,16h6V10H10Zm1-5h4v4H11Z', transform: 'translate(-2 -2)' }),
    _react2.default.createElement('path', { d: 'M10,2V8h6V2Zm5,5H11V3h4Z', transform: 'translate(-2 -2)' })
  );
}), _defineProperty(_$actualSize$archiv, 'devs', function devs(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 18 16' }, props),
    _react2.default.createElement('path', { d: 'M18,15V1H0V15H6v1H5v1h8V16H12V15ZM1,14V2H17V14Zm10,2H7V15h4Z', transform: 'translate(0 -1)',
      fill: '#050505' }),
    _react2.default.createElement('polygon', { points: '11.6 4.4 14.3 7 11.6 9.6 12.4 10.4 15.7 7 12.4 3.6 11.6 4.4', fill: '#050505' }),
    _react2.default.createElement('polygon', { points: '5.6 3.6 2.3 7 5.6 10.4 6.4 9.6 3.7 7 6.4 4.4 5.6 3.6', fill: '#050505' }),
    _react2.default.createElement('rect', { x: '4.9', y: '7.5', width: '8.2', height: '1', transform: 'translate(-0.9 13.8) rotate(-76)', fill: '#050505' })
  );
}), _defineProperty(_$actualSize$archiv, 'display', function display(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 32 27.6' }, props),
    _react2.default.createElement('path', {
      d: 'M32,24V2.2H0V24H15v3.9H11.2v1.9h9.7V27.9H17V24ZM1.9,4.1H30.1V18.2H1.9Zm0,18v-2H30.1v2Z',
      transform: 'translate(0 -2.2)'
    })
  );
}), _defineProperty(_$actualSize$archiv, 'dot', function dot(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 32 32' }, props),
    _react2.default.createElement('circle', { className: 'st0', cx: '16', cy: '16', r: '5.75' })
  );
}), _defineProperty(_$actualSize$archiv, 'dots', function dots(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 32 32' }, props),
    _react2.default.createElement('circle', { className: 'st0', cx: '16', cy: '3.7', r: '3.7' }),
    _react2.default.createElement('circle', { className: 'st0', cx: '16', cy: '15.9', r: '3.7' }),
    _react2.default.createElement('circle', { className: 'st0', cx: '16', cy: '28.3', r: '3.7' })
  );
}), _defineProperty(_$actualSize$archiv, 'envelope', function envelope(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 32 32' }, props),
    _react2.default.createElement('rect', { x: '18', y: '4', width: '4.5', height: '1' }),
    _react2.default.createElement('rect', { x: '9.5', y: '8', width: '13', height: '1' }),
    _react2.default.createElement('rect', { x: '9.5', y: '12', width: '13', height: '1' }),
    _react2.default.createElement('path', {
      d: 'M27,10.6V0H5V10.6L0,12.7V32H32V12.7Zm0,1.1,3.4,1.4L27,15.2ZM6,1H26V15.9L16,22.1,6,15.9ZM5,11.7v3.6L1.6,13.1ZM31,31H1V13.9l15,9.4,15-9.4Z'
    })
  );
}), _defineProperty(_$actualSize$archiv, 'error', function error(props) {
  return _react2.default.createElement(
    'svg',
    _extends({}, props, { viewBox: '0 0 32 32' }),
    _react2.default.createElement('path', {
      d: 'M27.3,4.7a16,16,0,1,0,0,22.6A16,16,0,0,0,27.3,4.7ZM24.7,21.2l-3.5,3.5L16,19.5l-5.2,5.2L7.3,21.2,12.5,16,7.3,10.8l3.5-3.5L16,12.5l5.2-5.2,3.5,3.5L19.5,16Z',
      transform: 'translate(0 0)'
    })
  );
}), _defineProperty(_$actualSize$archiv, 'eye', function eye(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 32 19.4' }, props),
    _react2.default.createElement('path', {
      d: 'M.1,14.1v1.2a18.7,18.7,0,0,0,31.9,2.5V16.7A18.7,18.7,0,0,0,.1,14.1Zm15.6,9.1a7.2,7.2,0,1,1,7.8-6.6A7.2,7.2,0,0,1,15.7,23.2Z',
      transform: 'translate(0 -6.3)' }),
    _react2.default.createElement('circle', { cx: '16.3', cy: '9.7', r: '3.6' })
  );
}), _defineProperty(_$actualSize$archiv, 'eye-cross', function eyeCross(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 32 19.4' }, props),
    _react2.default.createElement('path', {
      d: 'M25.7,9.5,28,6.9,23.5,3,20,6.9A18.6,18.6,0,0,0,.1,14.1v1.2a18.4,18.4,0,0,0,6.3,7.2L4,25.1,8.5,29,12,25.1a18.6,18.6,0,0,0,19.9-7.2V16.7A18.4,18.4,0,0,0,25.7,9.5ZM9.1,15.4a7.2,7.2,0,0,1,7.8-6.6l1.3.2L9.6,18.8A7.2,7.2,0,0,1,9.1,15.4Zm14.5,1.2a7.2,7.2,0,0,1-7.8,6.6L14,22.8l8.9-10A7.2,7.2,0,0,1,23.5,16.6Z',
      transform: 'translate(0 -3)' })
  );
}), _defineProperty(_$actualSize$archiv, 'filter', function filter(props) {
  return _react2.default.createElement(
    'svg',
    _extends({}, props, { viewBox: '0 0 26.7 32' }),
    _react2.default.createElement('path', {
      d: 'M27.9,0H4.2A1.5,1.5,0,0,0,2.9,2.3h0l9.6,13.5V26.9a1,1,0,0,0,.4.8l4.9,4.1.6.2h.4a1,1,0,0,0,.6-.9V15.8L29.1,2.3h0a1.5,1.5,0,0,0,0-1.5A1.4,1.4,0,0,0,27.9,0Z'
    })
  );
}), _defineProperty(_$actualSize$archiv, 'gripper', function gripper(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 18 18' }, props),
    _react2.default.createElement('circle', { cx: '6.5', cy: '3.5', r: '1.5' }),
    _react2.default.createElement('circle', { cx: '11.5', cy: '3.5', r: '1.5' }),
    _react2.default.createElement('circle', { cx: '6.5', cy: '8.5', r: '1.5' }),
    _react2.default.createElement('circle', { cx: '11.5', cy: '8.5', r: '1.5' }),
    _react2.default.createElement('circle', { cx: '6.5', cy: '13.5', r: '1.5' }),
    _react2.default.createElement('circle', { cx: '11.5', cy: '13.5', r: '1.5' })
  );
}), _defineProperty(_$actualSize$archiv, 'hamburger', function hamburger(props) {
  return _react2.default.createElement(
    'svg',
    _extends({}, props, { viewBox: '0 0 32 21.7' }),
    _react2.default.createElement('path', { d: 'M2,9.4H30c2.7,0,2.7-4.2,0-4.2H2C-.7,5.2-.7,9.4,2,9.4Z', transform: 'translate(0 -5.2)' }),
    _react2.default.createElement('path', { d: 'M30,13.9H2c-2.7,0-2.7,4.2,0,4.2H30C32.7,18.1,32.7,13.9,30,13.9Z', transform: 'translate(0 -5.2)' }),
    _react2.default.createElement('path', { d: 'M30,22.6H2c-2.7,0-2.7,4.2,0,4.2H30C32.7,26.8,32.7,22.6,30,22.6Z', transform: 'translate(0 -5.2)' })
  );
}), _defineProperty(_$actualSize$archiv, 'horizontal-dots', function horizontalDots(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 22 5.1' }, props),
    _react2.default.createElement('circle', { cx: '19.5', cy: '2.5', r: '2.5' }),
    _react2.default.createElement('circle', { cx: '11.1', cy: '2.5', r: '2.5' }),
    _react2.default.createElement('circle', { cx: '2.5', cy: '2.5', r: '2.5' })
  );
}), _defineProperty(_$actualSize$archiv, 'information', function information(props) {
  return _react2.default.createElement(
    'svg',
    _extends({}, props, { viewBox: '0 0 32 32' }),
    _react2.default.createElement('path', {
      d: 'M27.3,4.7a16,16,0,1,0,0,22.6A16,16,0,0,0,27.3,4.7ZM15.7,2.8a3.1,3.1,0,1,1-3.1,3.1A3.1,3.1,0,0,1,15.7,2.8Zm4.9,22.5a.8.8,0,0,1-1,1H11.8a.8.8,0,0,1-1-1v-2a.8.8,0,0,1,1-1h1.5V13.8H11.8a.8.8,0,0,1-1-1v-2a.8.8,0,0,1,1-1h5.5a.8.8,0,0,1,1,1V22.3h1.5a.8.8,0,0,1,1,1Z'
    })
  );
}), _defineProperty(_$actualSize$archiv, 'infinite', function infinite(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 32 13.1' }, props),
    _react2.default.createElement('path', {
      d: 'M6.9,9.5a7.2,7.2,0,0,0-4.7,1.9,6.1,6.1,0,0,0,0,9.3c2.8,2.5,6.8,2.6,10-.3l8.7-7.7c2.8-2.5,5.7-2.3,8.1-.3a4.6,4.6,0,0,1,0,7.1,5.5,5.5,0,0,1-7.3.3l-3.3-2.8a.7.7,0,1,0-.9,1.1L20.6,21a7.1,7.1,0,0,0,9.2-.3,6.1,6.1,0,0,0,0-9.3c-2.8-2.5-6.8-2.6-10,.3l-8.7,7.7c-2.8,2.5-5.7,2.4-8.1.3a4.6,4.6,0,0,1,0-7.2,5.5,5.5,0,0,1,7.3-.3l3.2,2.8a.7.7,0,1,0,.9-1.1L11.4,11A7.7,7.7,0,0,0,6.9,9.5Z',
      transform: 'translate(0 -9.5)' })
  );
}), _defineProperty(_$actualSize$archiv, 'lock', function lock(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 16 18' }, props),
    _react2.default.createElement('path', {
      d: 'M15,8H14V5A5,5,0,0,0,9,0,5,5,0,0,0,4,5V8H3a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2H15a2,2,0,0,0,2-2V10A2,2,0,0,0,15,8ZM5,5a4,4,0,0,1,8,0V8H5ZM16,16a.9.9,0,0,1-1,1H3a.9.9,0,0,1-1-1V10A.9.9,0,0,1,3,9H15a.9.9,0,0,1,1,1Z',
      transform: 'translate(-1)' }),
    _react2.default.createElement('path', {
      d: 'M9,10a2,2,0,0,0-.9,3.8c-.1,0-.1.1-.1.2v1a.9.9,0,0,0,1,1,.9.9,0,0,0,1-1V14c0-.1,0-.2-.1-.2A2.1,2.1,0,0,0,11,12,2,2,0,0,0,9,10Zm0,3a1,1,0,0,1,0-2,1,1,0,0,1,0,2Z',
      transform: 'translate(-1)' })
  );
}), _defineProperty(_$actualSize$archiv, 'location-tree', function locationTree(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 17 18' }, props),
    _react2.default.createElement('path', {
      d: 'M15,14V11H9V8.8c.7-.6,3-2.5,3-5.3A3.5,3.5,0,0,0,8.5,0,3.5,3.5,0,0,0,5,3.5C5,6.3,7.3,8.2,8,8.8V11H2v3H0v4H5V14H3V12H8v2H6v4h5V14H9V12h5v2H12v4h5V14ZM4,15v2H1V15Zm6,0v2H7V15ZM8.5,7.9C7.8,7.3,6,5.7,6,3.5a2.5,2.5,0,0,1,5,0C11,5.7,9.2,7.3,8.5,7.9ZM16,17H13V15h3Z' }),
    _react2.default.createElement('path', {
      d: 'M8.5,5A1.5,1.5,0,0,1,7,3.5a1.5,1.5,0,0,1,3,0A1.5,1.5,0,0,1,8.5,5Zm0-2a.5.5,0,0,0-.5.5.5.5,0,0,0,1,0A.5.5,0,0,0,8.5,3Z' })
  );
}), _defineProperty(_$actualSize$archiv, 'mail', function mail(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 18 12' }, props),
    _react2.default.createElement('path', { d: 'M0,3V15H18V3ZM16.6,4,9,9.5,1.4,4ZM17,14H1V4.9l8,5.8,8-5.8Z', transform: 'translate(0 -3)' })
  );
}), _defineProperty(_$actualSize$archiv, 'mail-filled', function mailFilled(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 18 18' }, props),
    _react2.default.createElement('path', { d: 'M17,3H9H1H0v1v11h1h16h1V4V3H17z M17,5.9l-7.4,5.3L9,11.7l-0.6-0.4L1,5.9V4.7l8,5.7l8-5.7V5.9z' })
  );
}), _defineProperty(_$actualSize$archiv, 'mail-settings', function mailSettings(props) {
  return _react2.default.createElement(
    'svg',
    { viewBox: '0 0 18 18' },
    _react2.default.createElement('path', { d: 'M6,10H1V2L7.4,6.8l.6.45.6-.45L15,2V6h1V0H0V11H6Zm8.667-9L8,6,1.333,1Z' }),
    _react2.default.createElement('path', {
      d: 'M12.5,18a5.461,5.461,0,0,1-.629-.039l-.328-.037-.477-1.59c-.089-.033-.176-.069-.262-.107l-1.461.785-.258-.2a5.7,5.7,0,0,1-.892-.892l-.205-.258L8.775,14.2c-.038-.085-.074-.173-.108-.262l-1.589-.477-.037-.328a5.092,5.092,0,0,1,0-1.258l.037-.328,1.59-.478c.033-.088.069-.176.108-.262L7.99,9.345,8.2,9.086a5.568,5.568,0,0,1,.891-.892l.258-.205,1.46.787c.086-.039.174-.075.263-.109l.477-1.589.328-.037a5.513,5.513,0,0,1,1.258,0l.328.037.477,1.59c.089.033.176.069.262.107l1.461-.786.258.205a5.645,5.645,0,0,1,.891.891l.206.258-.786,1.462c.039.085.075.173.107.261l1.59.478.037.328a5.092,5.092,0,0,1,0,1.258l-.037.328-1.59.477c-.033.089-.069.176-.107.262l.785,1.46-.205.258a5.61,5.61,0,0,1-.891.892l-.258.206L14.2,16.227c-.086.038-.173.074-.262.107l-.477,1.59-.328.037A5.447,5.447,0,0,1,12.5,18Zm-.191-1a3.744,3.744,0,0,0,.382,0l.437-1.454.258-.077a3.077,3.077,0,0,0,.582-.24l.237-.128,1.334.717c.094-.087.186-.178.273-.273L15.1,14.206l.128-.237a3.077,3.077,0,0,0,.24-.582l.077-.258L17,12.692c0-.063,0-.127,0-.191s0-.128,0-.192l-1.454-.437-.077-.259a3.091,3.091,0,0,0-.24-.58L15.1,10.8l.717-1.335c-.087-.094-.178-.186-.273-.273l-1.334.718-.237-.128a3.043,3.043,0,0,0-.581-.239l-.259-.077-.437-1.455a3.477,3.477,0,0,0-.382,0l-.437,1.455-.26.077a3.05,3.05,0,0,0-.578.238l-.238.131-1.335-.72c-.095.087-.186.179-.273.273L9.907,10.8l-.128.237a3.073,3.073,0,0,0-.24.581l-.077.259-1.455.437c0,.064,0,.128,0,.192s0,.128,0,.191l1.455.437.077.259a2.99,2.99,0,0,0,.239.581l.128.238L9.188,15.54c.087.1.179.187.274.273L10.8,15.1l.237.128a3.077,3.077,0,0,0,.582.24l.258.077Zm.191-2.524a1.97,1.97,0,1,1,1.97-1.97A1.973,1.973,0,0,1,12.5,14.471Zm0-2.94a.97.97,0,1,0,.97.97A.971.971,0,0,0,12.5,11.531Z' })
  );
}), _defineProperty(_$actualSize$archiv, 'manage-ip', function manageIp(props) {
  return _react2.default.createElement(
    'svg',
    _extends({}, props, { viewBox: '0 0 32 25.1' }),
    _react2.default.createElement('polygon', {
      points: '32 17.8 32 25.1 24 25.1 24 17.8 27.3 17.8 27.3 13.2 16.7 13.2 16.7 17.8 20 17.8 20 25.1 12 25.1 12 17.8 15.3 17.8 15.3 13.2 4.7 13.2 4.7 17.8 8 17.8 8 25.1 0 25.1 0 17.8 3.3 17.8 3.3 11.9 15.3 11.9 15.3 7.3 12 7.3 12 0 20 0 20 7.3 16.7 7.3 16.7 11.9 28.7 11.9 28.7 17.8 32 17.8' })
  );
}), _defineProperty(_$actualSize$archiv, 'marketplace', function marketplace(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 17 17' }, props),
    _react2.default.createElement('path', {
      d: 'M14,1H3L0,6V7.5a2.6,2.6,0,0,0,1,2V16H6v1H5v1h7V17H11V16h5V9.5a2.6,2.6,0,0,0,1-2V6Zm-.6,1,1.8,3H12.5L12,2ZM11,2l.5,3H9V2Zm1,5.5a1.5,1.5,0,0,1-3,0V6h2.7ZM5.3,6H8V7.5A1.5,1.5,0,0,1,6.5,9,1.5,1.5,0,0,1,5,7.5ZM8,2V5H5.5L6,2ZM3.6,2H5L4.5,5H1.8ZM1,6H4.3L4,7.5A1.5,1.5,0,0,1,2.5,9,1.5,1.5,0,0,1,1,7.5Zm9,11H7V16h3Zm5-2H2V9.9h.5a2.6,2.6,0,0,0,2-1A2.5,2.5,0,0,0,8,9.5L8.5,9a2.5,2.5,0,0,0,3.5.5l.5-.5a2.5,2.5,0,0,0,2.5.9Zm-.5-6A1.5,1.5,0,0,1,13,7.5L12.7,6H16V7.5A1.5,1.5,0,0,1,14.5,9Z',
      transform: 'translate(0 -1)' })
  );
}), _defineProperty(_$actualSize$archiv, 'new-staging', function newStaging(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 18 18' }, props),
    _react2.default.createElement('path', { d: 'M8,13H5V5H16V9h1V0H0V14H8ZM1,1H16V4H1ZM4,13H1V5H4Z' }),
    _react2.default.createElement('polygon', { points: '16 13 14 13 14 11 13 11 13 13 11 13 11 14 13 14 13 16 14 16 14 14 16 14 16 13' }),
    _react2.default.createElement('path', { d: 'M13.5,10A3.5,3.5,0,1,1,10,13.5,3.5,3.5,0,0,1,13.5,10m0-1A4.5,4.5,0,1,0,18,13.5,4.5,4.5,0,0,0,13.5,9Z' })
  );
}), _defineProperty(_$actualSize$archiv, 'plus', function plus(props) {
  return _react2.default.createElement(
    'svg',
    _extends({}, props, { viewBox: '0 0 32 32' }),
    _react2.default.createElement('polygon', {
      points: '32 15.1 32 16.9 16.9 16.9 16.9 32 15.1 32 15.1 16.9 0 16.9 0 15.1 15.1 15.1 15.1 0 16.9 0 16.9 15.1 32 15.1'
    })
  );
}), _defineProperty(_$actualSize$archiv, 'profile', function profile(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 26.5 32' }, props),
    _react2.default.createElement('path', {
      d: 'M16,1.8a5.5,5.5,0,1,1-5.5,5.5A5.5,5.5,0,0,1,16,1.8M16,0a7.3,7.3,0,1,0,7.3,7.3A7.3,7.3,0,0,0,16,0Z',
      transform: 'translate(-2.7)' }),
    _react2.default.createElement('path', {
      d: 'M25.6,20.4a1.8,1.8,0,0,1,1.8,1.8v7.9H4.6V22.2a1.8,1.8,0,0,1,1.8-1.8H25.6m0-1.8H6.4a3.7,3.7,0,0,0-3.7,3.7V32H29.3V22.2a3.7,3.7,0,0,0-3.7-3.7Z',
      transform: 'translate(-2.7)' })
  );
}), _defineProperty(_$actualSize$archiv, 'question-mark', function questionMark(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 18 18' }, props),
    _react2.default.createElement('path', {
      d: 'M10.2,13a1,1,0,1,1-1-1A1,1,0,0,1,10.2,13Zm1-8a2.4,2.4,0,0,1,.6,1.9,3.8,3.8,0,0,1-1.4,2,2,2,0,0,0-.9,1.6h-1A3,3,0,0,1,9.7,8.1a2.9,2.9,0,0,0,1.1-1.5,1.5,1.5,0,0,0-.4-1A1.5,1.5,0,0,0,9.1,5,1.7,1.7,0,0,0,7.3,6.6h-1A2.7,2.7,0,0,1,9.1,4,2.5,2.5,0,0,1,11.2,5Z',
      transform: 'translate(0)' }),
    _react2.default.createElement('path', { d: 'M9,1A8,8,0,1,1,1,9,8,8,0,0,1,9,1M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0Z', transform: 'translate(0)' })
  );
}), _defineProperty(_$actualSize$archiv, 'rocket', function rocket(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 17.7 17.7' }, props),
    _react2.default.createElement('path', { d: 'M13,3a2,2,0,1,0,2,2A2,2,0,0,0,13,3Zm0,3a.9.9,0,0,1-1-1,1,1,0,0,1,2,0A.9.9,0,0,1,13,6Z',
      transform: 'translate(-0.3)', fill: '#050505' }),
    _react2.default.createElement('path', {
      d: 'M18,0H16A12.1,12.1,0,0,0,7.5,3.5H2.6l-2.3,7H3.6L3,12l3,3,1.5-.6v3.3l7-2.3V10.5A12.1,12.1,0,0,0,18,2ZM1.7,9.5l1.7-5H6.7A10.8,10.8,0,0,0,4.9,7.4L4,9.5Zm6.8,6.8V13.9l2.1-.9a10.5,10.5,0,0,0,2.9-1.7v3.3ZM17,2a11.1,11.1,0,0,1-6.8,10.2l-4,1.7-2-2,1.7-4A10.8,10.8,0,0,1,16,1h1Z',
      transform: 'translate(-0.3)', fill: '#050505' })
  );
}), _defineProperty(_$actualSize$archiv, 'settings', function settings(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 32 32' }, props),
    _react2.default.createElement('path', {
      d: 'M16,12.4A3.6,3.6,0,1,1,12.4,16,3.6,3.6,0,0,1,16,12.4m0-1.8A5.3,5.3,0,1,0,21.3,16,5.3,5.3,0,0,0,16,10.7Z' }),
    _react2.default.createElement('path', {
      d: 'M17.8,1.8V5.4l1.3.4,2,.8,1.2.6.9-.9,1.7-1.7,2.5,2.5L25.7,8.8l-.9.9.6,1.2a10.6,10.6,0,0,1,.8,2l.4,1.3h3.6v3.6H26.6L26.2,19a10.6,10.6,0,0,1-.8,2l-.6,1.2.9.9,1.7,1.7-2.5,2.5-1.7-1.7-.9-.9-1.2.6-2,.8-1.3.4v3.6H14.2V26.6L13,26.2l-2-.8-1.2-.6-.9.9L7.1,27.4,4.6,24.9l1.7-1.7.9-.9-.6-1.2a10.6,10.6,0,0,1-.8-2l-.4-1.3H1.8V14.2H5.4L5.8,13a10.6,10.6,0,0,1,.8-2l.6-1.2-.9-.9L4.6,7.1,7.1,4.6,8.8,6.3l.9.9,1.2-.6,2-.8,1.3-.4V1.8h3.6M19.6,0H12.4V4.1l-2.4,1-3-3-5,5,3,3a12.4,12.4,0,0,0-1,2.4H0v7.1H4.1a12.4,12.4,0,0,0,1,2.4l-3,3,5,5,3-3,2.4,1V32h7.1V27.9l2.4-1,3,3,5-5-3-3a12.4,12.4,0,0,0,1-2.4H32V12.4H27.9a12.4,12.4,0,0,0-1-2.4l3-3-5-5-3,3-2.4-1V0Z' })
  );
}), _defineProperty(_$actualSize$archiv, 'star', function star(props) {
  return _react2.default.createElement(
    'svg',
    _extends({}, props, { viewBox: '0 0 22 21' }),
    _react2.default.createElement('path', {
      d: 'M11,1a.225.225,0,0,1,.2.1l2.92,5.374.212.389.431.105,6.051,1.466a.244.244,0,0,1,.111.411L16.405,12.2l-.483.358.089.594.969,6.484,0,.035.008.034a.223.223,0,0,1-.043.2.257.257,0,0,1-.193.1.321.321,0,0,1-.075-.01l-5.2-2.866L11,16.858l-.483.266L5.354,19.971A.239.239,0,0,1,5.243,20a.257.257,0,0,1-.193-.1.223.223,0,0,1-.043-.2l.008-.034,0-.035.969-6.484.089-.594L5.6,12.2,1.074,8.849a.244.244,0,0,1,.1-.409L7.236,6.972l.431-.105.212-.389,2.91-5.355A.232.232,0,0,1,11,1m0-1A1.231,1.231,0,0,0,9.921.626L7,6,.942,7.468A1.243,1.243,0,0,0,.448,9.629L5,13l-.969,6.484A1.24,1.24,0,0,0,5.8,20.866L11,18l5.2,2.866a1.24,1.24,0,0,0,1.77-1.382L17,13l4.552-3.371a1.243,1.243,0,0,0-.494-2.161L15,6,12.079.626A1.231,1.231,0,0,0,11,0Z' })
  );
}), _defineProperty(_$actualSize$archiv, 'star-filled', function starFilled(props) {
  return _react2.default.createElement(
    'svg',
    _extends({}, props, { viewBox: '0 0 22 21' }),
    _react2.default.createElement('path', {
      d: 'M11,18l5.2,2.866a1.244,1.244,0,0,0,1.77-1.382L17,13l4.552-3.371a1.243,1.243,0,0,0-.494-2.161L15,6,12.079.626a1.243,1.243,0,0,0-2.158,0L7,6,.942,7.468A1.243,1.243,0,0,0,.448,9.629L5,13l-.969,6.484A1.244,1.244,0,0,0,5.8,20.866Z' })
  );
}), _defineProperty(_$actualSize$archiv, 'statistics', function statistics(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 17 17' }, props),
    _react2.default.createElement('path', { d: 'M9,2H8a8,8,0,1,0,8,8V9H9Zm6,8a7,7,0,0,1-7,7A7,7,0,0,1,8,3v7Z', transform: 'translate(0 -1)' }),
    _react2.default.createElement('path', { d: 'M11,1H10V8h7V7A6,6,0,0,0,11,1Zm0,6V2a5,5,0,0,1,5,5Z', transform: 'translate(0 -1)' })
  );
}), _defineProperty(_$actualSize$archiv, 'services', function services(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 18 18' }, props),
    _react2.default.createElement('path', { d: 'M9,1.1l3,1.7V6.1L9,7.8,6,6.2V2.8L9,1.1M9,0,5,2.2V6.7L9,9l4-2.2V2.2Z', fill: '#050505' }),
    _react2.default.createElement('polygon', { points: '7.5 5.5 6.5 5.5 6.5 3.2 8.5 2.1 9 2.9 7.5 3.8 7.5 5.5', fill: '#050505' }),
    _react2.default.createElement('path', { d: 'M4,10.1l3,1.7v3.3L4,16.8,1,15.1V11.8l3-1.7M4,9,0,11.2v4.5L4,18l4-2.2V11.3Z', fill: '#050505' }),
    _react2.default.createElement('polygon', { points: '2.5 14.5 1.5 14.5 1.5 12.2 3.5 11.1 4 11.9 2.5 12.8 2.5 14.5', fill: '#050505' }),
    _react2.default.createElement('path', { d: 'M14,10.1l3,1.7v3.3l-3,1.7-3-1.7V11.8l3-1.7M14,9l-4,2.2v4.5l4,2.2,4-2.2V11.2Z', fill: '#050505' }),
    _react2.default.createElement('polygon', { points: '12.5 14.5 11.5 14.5 11.5 12.2 13.5 11.1 14 11.9 12.5 12.8 12.5 14.5', fill: '#050505' })
  );
}), _defineProperty(_$actualSize$archiv, 'success', function success(props) {
  return _react2.default.createElement(
    'svg',
    _extends({}, props, { viewBox: '0 0 32 32' }),
    _react2.default.createElement('path', { d: 'M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0ZM14,23.3,6.5,15.8l3-3L14,17.3l8.5-8.5,3,3Z' })
  );
}), _defineProperty(_$actualSize$archiv, 'support', function support(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 32 32' }, props),
    _react2.default.createElement('path', {
      d: 'M9.79,1.27a15.86,15.86,0,0,1,12.43,0,15.72,15.72,0,0,1,8.52,8.52,15.86,15.86,0,0,1,0,12.43,15.72,15.72,0,0,1-8.52,8.52,15.86,15.86,0,0,1-12.43,0,15.72,15.72,0,0,1-8.52-8.52,15.86,15.86,0,0,1,0-12.43A15.72,15.72,0,0,1,9.79,1.27ZM3.89,22.45,7.36,19a9.14,9.14,0,0,1,0-6L3.89,9.55a13.73,13.73,0,0,0,0,12.89Zm7.26-1.6a6.61,6.61,0,0,0,4.85,2A6.86,6.86,0,0,0,22.86,16,6.86,6.86,0,0,0,16,9.14,6.86,6.86,0,0,0,9.14,16,6.61,6.61,0,0,0,11.15,20.85ZM16,2.29A13.65,13.65,0,0,0,9.55,3.89L13,7.36a9.14,9.14,0,0,1,6,0l3.46-3.46A13.65,13.65,0,0,0,16,2.29Zm0,27.43a13.65,13.65,0,0,0,6.45-1.61L19,24.64a9.14,9.14,0,0,1-6,0L9.55,28.11A13.65,13.65,0,0,0,16,29.71ZM24.64,19l3.46,3.46a13.73,13.73,0,0,0,0-12.89L24.64,13a9.14,9.14,0,0,1,0,6Z' })
  );
}), _defineProperty(_$actualSize$archiv, 'touch', function touch(props) {
  return _react2.default.createElement(
    'svg',
    _extends({}, props, { viewBox: '0 0 32 32' }),
    _react2.default.createElement('path', {
      d: 'M22.25,14.19a.53.53,0,0,0,.31-.27,9.93,9.93,0,0,0,.92-4.2A9.53,9.53,0,0,0,14.16,0,9.53,9.53,0,0,0,4.85,9.72a9.9,9.9,0,0,0,.92,4.2.48.48,0,0,0,.27.27.46.46,0,0,0,.38,0,.49.49,0,0,0,.26-.27.42.42,0,0,0,0-.3l0-.11a9,9,0,0,1-.82-3.78A8.56,8.56,0,0,1,14.16,1a8.56,8.56,0,0,1,8.34,8.74,9,9,0,0,1-.83,3.79.49.49,0,0,0,.21.66A.47.47,0,0,0,22.25,14.19Z',
      transform: 'translate(-4.85)' }),
    _react2.default.createElement('path', {
      d: 'M19,13.14a.48.48,0,0,0,.61-.2,7,7,0,0,0,.85-3.34,6.54,6.54,0,0,0-6.33-6.72A6.54,6.54,0,0,0,7.84,9.59a7,7,0,0,0,.85,3.35.46.46,0,0,0,.63.18.47.47,0,0,0,.18-.63,6,6,0,0,1-.74-2.89,5.61,5.61,0,0,1,5.4-5.79,5.61,5.61,0,0,1,5.4,5.79,6,6,0,0,1-.73,2.89.45.45,0,0,0,0,.36.47.47,0,0,0,.22.28Z',
      transform: 'translate(-4.85)' }),
    _react2.default.createElement('path', {
      d: 'M26.87,18.91a3.27,3.27,0,0,0-2.73-2.6,3.34,3.34,0,0,0-1,.11,2.09,2.09,0,0,0-.72-1A2.52,2.52,0,0,0,21,14.94h0a1.78,1.78,0,0,0-1.08.41,1.88,1.88,0,0,0-.52-.62,2.49,2.49,0,0,0-2.53-.22V8.73A2.69,2.69,0,0,0,14.19,6h0a2.71,2.71,0,0,0-2.71,2.71V18.3L11.32,18a3.9,3.9,0,0,0-2.06-2,2.46,2.46,0,0,0-1.94.35,2.74,2.74,0,0,0-1.27,1.53,3.73,3.73,0,0,0,.3,2.36,49.28,49.28,0,0,0,5,9.34A5.54,5.54,0,0,0,15.87,32h3.85a6.38,6.38,0,0,0,5.57-3.08,5.46,5.46,0,0,0,.25-.5A19,19,0,0,0,27,23.55,11.37,11.37,0,0,0,26.87,18.91Zm-2.81-1.3c.78.11,1.26.61,1.55,1.65a10.14,10.14,0,0,1,.07,4.09,18.42,18.42,0,0,1-1.33,4.55l0,0a4.82,4.82,0,0,1-4.42,2.77H16.24a4.94,4.94,0,0,1-4.09-2.18A48.68,48.68,0,0,1,7.58,19.8a2.73,2.73,0,0,1-.27-1.52A1.4,1.4,0,0,1,8,17.5a1.23,1.23,0,0,1,.87-.23,2.7,2.7,0,0,1,1.29,1.35l1.36,2.73a.69.69,0,0,0,.73.36.66.66,0,0,0,.51-.64V8.73a1.39,1.39,0,0,1,1.33-1.4h.07a1.39,1.39,0,0,1,1.4,1.4v7.2a.65.65,0,0,0,1.24.27,1.4,1.4,0,0,1,1.12-.65,1.29,1.29,0,0,1,.7.21.91.91,0,0,1,.36.85.67.67,0,0,0,.51.65.66.66,0,0,0,.73-.36c.28-.56.48-.66.8-.66a1.17,1.17,0,0,1,.66.21.92.92,0,0,1,.38.86.67.67,0,0,0,1.09.47.92.92,0,0,1,.33-.12A3.28,3.28,0,0,1,24.06,17.61Z',
      transform: 'translate(-4.85)' })
  );
}), _defineProperty(_$actualSize$archiv, 'user', function user(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 26.67 32' }, props),
    _react2.default.createElement('path', {
      d: 'M29.33,26.48a6,6,0,0,1-1.3,3.9A3.9,3.9,0,0,1,24.9,32H7.1A3.9,3.9,0,0,1,4,30.37a6,6,0,0,1-1.3-3.9,30.07,30.07,0,0,1,.18-3.34A18.05,18.05,0,0,1,3.5,20a10.52,10.52,0,0,1,1.22-2.73,5.82,5.82,0,0,1,2-1.85,5.41,5.41,0,0,1,2.8-.72A9,9,0,0,0,16,17.33a9,9,0,0,0,6.52-2.67,5.41,5.41,0,0,1,2.8.72,5.82,5.82,0,0,1,2,1.85A10.52,10.52,0,0,1,28.5,20a18.05,18.05,0,0,1,.66,3.17A30.07,30.07,0,0,1,29.33,26.48ZM21.66,2.34A7.71,7.71,0,0,1,24,8a7.71,7.71,0,0,1-2.34,5.66A7.71,7.71,0,0,1,16,16a7.71,7.71,0,0,1-5.66-2.34A7.71,7.71,0,0,1,8,8a7.71,7.71,0,0,1,2.34-5.66A7.71,7.71,0,0,1,16,0,7.71,7.71,0,0,1,21.66,2.34Z',
      transform: 'translate(-2.67)' })
  );
}), _defineProperty(_$actualSize$archiv, 'users', function users(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 18 12' }, props),
    _react2.default.createElement('path', { d: 'M3,9a2,2,0,0,0-2,2v1H4.1a6.7,6.7,0,0,1,.7-1.8A2,2,0,0,0,3,9Z', transform: 'translate(0 -3)', fill: 'none' }),
    _react2.default.createElement('path', { d: 'M17,12V11a2,2,0,0,0-2-2,2,2,0,0,0-1.8,1.2,3.6,3.6,0,0,1,.7,1.8Z', transform: 'translate(0 -3)',
      fill: 'none' }),
    _react2.default.createElement('path', {
      d: 'M16.4,8.4A2,2,0,0,0,17,7a2,2,0,0,0-4,0,2,2,0,0,0,.6,1.4,3.5,3.5,0,0,0-1.1,1,3.9,3.9,0,0,0-1.6-1A3.4,3.4,0,0,0,12,6,2.9,2.9,0,0,0,9,3,2.9,2.9,0,0,0,6,6,2.8,2.8,0,0,0,7.2,8.3,6.2,6.2,0,0,0,5.5,9.4a3.5,3.5,0,0,0-1.1-1A2,2,0,0,0,5,7,2,2,0,0,0,1,7a2,2,0,0,0,.6,1.4H1.4A2.9,2.9,0,0,0,0,11v2H4v2H14V13h4V11A2.9,2.9,0,0,0,16.4,8.4ZM14,7a1,1,0,0,1,2,0,1,1,0,0,1-2,0ZM7,6A2,2,0,1,1,9,8,2,2,0,0,1,7,6ZM3,6A.9.9,0,0,1,4,7,.9.9,0,0,1,3,8,.9.9,0,0,1,2,7,.9.9,0,0,1,3,6Zm1.1,6H1V11A2,2,0,0,1,3,9H3a2,2,0,0,1,1.8,1.2A6.7,6.7,0,0,0,4.1,12ZM13,14H5V13a4,4,0,0,1,8,0Zm4-2H13.9a6.7,6.7,0,0,0-.7-1.8A2,2,0,0,1,15,9h0l.7.2A2,2,0,0,1,16.9,11v1Z',
      transform: 'translate(0 -3)' })
  );
}), _defineProperty(_$actualSize$archiv, 'renew', function renew(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 15.97 15.87' }, props),
    _react2.default.createElement('path', { d: 'M16,2.34,15.43,4.9A7.29,7.29,0,0,0,2.07,6.13l1,.31a6.28,6.28,0,0,1,11.71-.69l-3-.68-.23,1,4.41,1,1-4.5Z',
      transform: 'translate(-1.01 -1.06)' }),
    _react2.default.createElement('path', {
      d: 'M9,15.94a6.27,6.27,0,0,1-5.71-3.69l2.95.68.23-1L2,10.94l-1,4.5,1,.22.58-2.56a7.29,7.29,0,0,0,13.36-1.23L15,11.56A6.28,6.28,0,0,1,9,15.94Z',
      transform: 'translate(-1.01 -1.06)' })
  );
}), _defineProperty(_$actualSize$archiv, 'refresh', function refresh(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 32 32' }, props),
    _react2.default.createElement('path', { d: 'M27.3,4.7A16,16,0,1,0,31.4,20H27.3A12,12,0,1,1,16,4a11.8,11.8,0,0,1,8.4,3.6L18,14H32V0Z',
      transform: 'translate(0)' })
  );
}), _defineProperty(_$actualSize$archiv, 'restore', function restore(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 18 18' }, props),
    _react2.default.createElement('path', { d: 'M17.6,9c0,3.9-3.1,7-7,7v-1c3.3,0,6-2.7,6-6s-2.7-6-6-6s-6,2.7-6,6v0.4L7,7l0.7,0.7L4.4,11H3.8L0.4,7.7L1.1,7l2.5,2.4V9 c0-3.9,3.1-7,7-7S17.6,5.1,17.6,9z' })
  );
}), _defineProperty(_$actualSize$archiv, 'ssl', function ssl(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 16.04 18' }, props),
    _react2.default.createElement('path', {
      d: 'M9,1.29a15.7,15.7,0,0,0,7,3.17c0,2.88-.26,5.78-1.53,8A10.64,10.64,0,0,1,9,17a10.32,10.32,0,0,1-5.63-4.48C2.11,10.3,2,7.37,2,4.46A15.75,15.75,0,0,0,9,1.29M9,0S5,3.52,1,3.52C1,7,1,10.36,2.48,13A11.19,11.19,0,0,0,9,18a11.45,11.45,0,0,0,6.36-5C16.86,10.34,17,7,17,3.52,13,3.52,9,0,9,0Z',
      transform: 'translate(-0.98)', fill: '#050505' }),
    _react2.default.createElement('polygon', { points: '12.02 10 12.02 6 11.02 6 11.02 11 13.02 11 13.02 10 12.02 10' }),
    _react2.default.createElement('polygon', {
      points: '10.02 7 10.02 6 7.02 6 7.02 9 9.02 9 9.02 10 7.02 10 7.02 11 10.02 11 10.02 8 8.02 8 8.02 7 10.02 7' }),
    _react2.default.createElement('polygon', {
      points: '6.02 7 6.02 6 3.02 6 3.02 9 5.02 9 5.02 10 3.02 10 3.02 11 6.02 11 6.02 8 4.02 8 4.02 7 6.02 7' })
  );
}), _defineProperty(_$actualSize$archiv, 'wallet', function wallet(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 24 24' }, props),
    _react2.default.createElement('path', { fill: '#7D7D7D',
      d: 'M24 18V2.8c0-.4-.3-.6-.6-.6H22c-.4 0-.6-.3-.6-.6v-1c0-.4-.3-.6-.6-.6H2.1C1 0 0 .9 0 2v14.6c0 1.1.9 2 2.1 2h21.3c.3.1.6-.2.6-.6zM20.1 2v2.7c0 .4-.3.6-.6.6h-3.2c-1.1 0-2.1.9-2.1 2v1.3c0 1.1.9 2 2.1 2h3.2c.4 0 .6.3.6.6V14c0 .4-.3.6-.6.6H2.1c-.2 0-.4 0-.6.1h-.1V2c0-.4.3-.7.7-.7h17.3c.4 0 .7.3.7.7zm2.6 5.3v1.4c0 .4-.3.6-.6.6h-5.8c-.4 0-.7-.3-.7-.7V7.3c0-.4.3-.7.7-.7H22c.4.1.7.3.7.7zm-.7-2c-.4 0-.6-.3-.6-.6v-.5c0-.4.3-.6.6-.6.4 0 .6.3.6.6v.5c.1.3-.2.6-.6.6zm.7 6v5.4c0 .4-.3.6-.6.6h-20c-.4 0-.7-.3-.7-.7 0-.4.4-.6.7-.6h18.6c.4 0 .6-.3.6-.6v-4.1c0-.4.3-.6.6-.6.5 0 .8.2.8.6z' })
  );
}), _defineProperty(_$actualSize$archiv, 'warning', function warning(props) {
  return _react2.default.createElement(
    'svg',
    _extends({}, props, { viewBox: '0 0 32 32' }),
    _react2.default.createElement('path', {
      d: 'M27.3,4.7a16,16,0,1,0,0,22.6A16,16,0,0,0,27.3,4.7ZM15,6.7h3c.9,0,1,.5,1,.8v.6l-.6,10.9c-.1.8-.5,1-1.1,1H15.8c-.6,0-1-.2-1.1-1L14.1,8.1V7.5C14.1,7.2,14.2,6.7,15,6.7Zm1.5,21a2.8,2.8,0,1,1,2.8-2.8A2.8,2.8,0,0,1,16.6,27.7Z'
    })
  );
}), _defineProperty(_$actualSize$archiv, 'websites', function websites(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 18 16' }, props),
    _react2.default.createElement('path', { d: 'M8,8v6H3V8H8M9,7H2v8H9Z', transform: 'translate(0 -1)' }),
    _react2.default.createElement('path', { d: 'M15,8v2H11V8h4m1-1H10v4h6Z', transform: 'translate(0 -1)' }),
    _react2.default.createElement('polygon', { points: '3 2 2 2 2 3 3 3 3 2' }),
    _react2.default.createElement('polygon', { points: '5 2 4 2 4 3 5 3 5 2' }),
    _react2.default.createElement('polygon', { points: '7 2 6 2 6 3 7 3 7 2' }),
    _react2.default.createElement('polygon', { points: '16 11 10 11 10 12 16 12 16 11' }),
    _react2.default.createElement('polygon', { points: '16 13 10 13 10 14 16 14 16 13' }),
    _react2.default.createElement('path', { d: 'M0,1V17H18V1ZM17,16H1V6H17ZM17,5H1V2H17Z', transform: 'translate(0 -1)' })
  );
}), _defineProperty(_$actualSize$archiv, 'wordpress', function wordpress(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 18 18' }, props),
    _react2.default.createElement('path', {
      d: 'M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0ZM1,9a8.7,8.7,0,0,1,.6-3.2L5.4,16.1A7.9,7.9,0,0,1,1,9ZM9,1a7.9,7.9,0,0,1,5.3,2A1.4,1.4,0,0,0,13,4.5a4.1,4.1,0,0,0,.8,1.9,4.4,4.4,0,0,1,.7,2.2,11,11,0,0,1-.6,2.6L13,13.9,10.1,5.2H11c.2,0,.3-.2.3-.4a.3.3,0,0,0-.3-.3H6.7c-.4,0-.5.7,0,.7h.8L8.7,8.7,7,14,4,5.2h.9c.2,0,.3-.2.3-.4a.3.3,0,0,0-.3-.3H2.3A8.1,8.1,0,0,1,9,1ZM9,17a7.8,7.8,0,0,1-2.2-.3l2.4-7,2.5,6.8h0A8.6,8.6,0,0,1,9,17Zm6.5-8.1A10.2,10.2,0,0,0,16.2,6V5.4a8,8,0,0,1-3,10.5Z' })
  );
}), _defineProperty(_$actualSize$archiv, 'domain', function domain(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 18 18' }, props),
    _react2.default.createElement('path', {
      d: 'M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0Zm7.4,6H12.8A11.2,11.2,0,0,0,11,1.3,8,8,0,0,1,16.4,6ZM12,9a13.4,13.4,0,0,1-.1,2H6.1a26.7,26.7,0,0,1,0-4h5.8A13.4,13.4,0,0,1,12,9ZM9,17c-.9,0-2.2-1.9-2.8-5h5.6C11.2,15.1,10,17,9,17ZM6.2,6C6.8,2.9,8.1,1,9,1s2.2,1.9,2.8,5ZM7,1.3A11.2,11.2,0,0,0,5.2,6H1.6A8,8,0,0,1,7,1.3ZM1.3,7H5.1A12.7,12.7,0,0,0,5,9a12.7,12.7,0,0,0,.1,2H1.3a6.8,6.8,0,0,1,0-4Zm.3,5H5.2A11.2,11.2,0,0,0,7,16.7,8,8,0,0,1,1.6,12ZM11,16.7A11.2,11.2,0,0,0,12.8,12h3.6A8,8,0,0,1,11,16.7ZM16.7,11H12.9A12.7,12.7,0,0,0,13,9a12.7,12.7,0,0,0-.1-2h3.8a6.8,6.8,0,0,1,0,4Z',
      fill: '#050505' })
  );
}), _defineProperty(_$actualSize$archiv, 'wp-joomla', function wpJoomla(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 32 25' }, props),
    _react2.default.createElement('path', {
      d: 'M22.209 6.423c.366.361.732.723 1.09 1.092.079.081.116.072.19 0q1.344-1.35 2.693-2.693a1.042 1.042 0 0 1 1.823.768 1.114 1.114 0 0 1-.341.7c-.046.046-.047.071 0 .117q.575.57 1.144 1.145c.052.053.078.045.126 0a2.891 2.891 0 0 0 .534-.714 2.812 2.812 0 0 0 .251-1.962c-.014-.064-.069-.142.07-.166a1.691 1.691 0 0 0 1.37-1.522h.022v-.3a.05.05 0 0 0-.021 0c-.01-.065-.016-.131-.028-.2a1.7 1.7 0 0 0-1.468-1.348.018.018 0 0 1 0-.023h-.4a.022.022 0 0 1 0 .022 1.693 1.693 0 0 0-1.465 1.321c-.019.1-.04.149-.152.105a.9.9 0 0 0-.217-.05 2.811 2.811 0 0 0-2.466.8c-.922.915-1.837 1.836-2.758 2.752-.072.07-.056.1.003.156z',
      fill: '#ccaf83' }),
    _react2.default.createElement('path', {
      d: 'M19.65 4.657c.1.03.127.062.094.166a2.181 2.181 0 0 0-.084.638 2.791 2.791 0 0 0 .838 2.058q1.376 1.379 2.753 2.756c.059.059.088.056.144 0a96.63 96.63 0 0 1 1.109-1.109c.067-.067.07-.1 0-.17q-1.343-1.332-2.678-2.673a2.071 2.071 0 0 1-.182-.2 1.045 1.045 0 0 1 .314-1.51 1.031 1.031 0 0 1 1.283.182c.069.067.1.062.163 0q.555-.564 1.118-1.118c.054-.053.055-.08 0-.133a2.813 2.813 0 0 0-2.557-.8c-.084.015-.128.011-.15-.1a1.7 1.7 0 0 0-1.46-1.3.025.025 0 0 1 0-.022h-.4a.02.02 0 0 1 0 .022 1.7 1.7 0 0 0-1.5 1.57.018.018 0 0 0-.02 0v.274a.083.083 0 0 1 .022 0 1.712 1.712 0 0 0 1.193 1.469z',
      fill: '#ccaf83' }),
    _react2.default.createElement('path', {
      d: 'M31.496 22.088h-4.341a1.855 1.855 0 0 0-1.757-1.515v-8.241a2.755 2.755 0 0 0 2.3.39c.083-.021.1-.005.126.08a1.713 1.713 0 0 0 1.455 1.245.046.046 0 0 0 .005.02h.374a.032.032 0 0 0 0-.014 1.288 1.288 0 0 0 .8-.273 1.593 1.593 0 0 0 .714-1.207v-.448c-.006-.006-.015-.011-.017-.018a1.67 1.67 0 0 0-1.377-1.428c-.063-.014-.063-.047-.054-.1a3.1 3.1 0 0 0 .057-.48 2.671 2.671 0 0 0-.731-2.011c-.937-.97-1.9-1.914-2.851-2.872-.068-.068-.094-.022-.135.019-.364.364-.726.73-1.095 1.089-.082.08-.076.12 0 .2q1.356 1.349 2.7 2.7a1.042 1.042 0 1 1-1.467 1.476c-.05-.049-.075-.063-.133 0-.289.3-.582.586-.876.877a.489.489 0 0 0-.2-.09c.761-.75 1.512-1.509 2.269-2.263.066-.066.026-.093-.016-.135-.365-.363-.731-.724-1.09-1.094-.081-.084-.122-.073-.2 0q-1.342 1.352-2.692 2.7a1.024 1.024 0 0 1-1.1.291.989.989 0 0 1-.7-.793 1.024 1.024 0 0 1 .313-.962c.038-.039.077-.063.015-.124q-.581-.573-1.154-1.152c-.041-.042-.065-.046-.108 0a2.811 2.811 0 0 0-.684 1.038 2.728 2.728 0 0 0-.121 1.6c.016.072.011.118-.078.144a1.672 1.672 0 0 0-1.1 1c-.052.121-.055.256-.118.372v.5a1.332 1.332 0 0 0 .2.618 1.564 1.564 0 0 0 1.316.836v.015h.373v-.021a1.69 1.69 0 0 0 1.434-1.186c.031-.1.066-.118.169-.1a2.715 2.715 0 0 0 2.463-.694v8.511a1.854 1.854 0 0 0-1.6 1.5h-12.67a1.854 1.854 0 0 0-1.681-1.508v-5.058c0-.011-.006-.021-.007-.033a7.8 7.8 0 1 0-1 .017v5.072a1.855 1.855 0 0 0-1.676 1.51h-4.6a.503.503 0 1 0 0 1.006h4.57v.049a1.86 1.86 0 0 0 1.858 1.859h.719a1.861 1.861 0 0 0 1.853-1.861v-.053h12.6v.049a1.861 1.861 0 0 0 1.858 1.859h.719a1.861 1.861 0 0 0 1.859-1.859v-.049h4.307a.503.503 0 1 0 0-1.006zm-18.111-14.4a8.74 8.74 0 0 0 .5-1.877 5.542 5.542 0 0 0 .008-1.294c.639.67 1.01 3.1.7 4.582a6.99 6.99 0 0 1-3.3 4.671 1.134 1.134 0 0 1 .095-.336c.668-1.915 1.324-3.833 1.997-5.746zM6.171.974a6.888 6.888 0 0 1 6.259 1.63 1.208 1.208 0 0 0-1.215 1.435 2.982 2.982 0 0 0 .48 1.131 5.08 5.08 0 0 1 .658 1.378 3.835 3.835 0 0 1-.117 2.212c-.343 1.049-.666 2.1-.979 3.164-.069-.025-.061-.093-.077-.14q-1.107-3.285-2.208-6.571c-.066-.2-.128-.392-.2-.585-.036-.095-.034-.136.085-.141.211-.008.422-.03.632-.053a.3.3 0 0 0 .271-.418.256.256 0 0 0-.269-.168c-.557.03-1.113.069-1.672.082-.392.009-.783-.016-1.175-.03-.289-.011-.577-.039-.866-.052a.28.28 0 0 0-.308.277.274.274 0 0 0 .263.3c.205.026.41.045.616.059a.153.153 0 0 1 .157.115q.5 1.39 1.01 2.778a.228.228 0 0 1 .009.163c-.5 1.476-.988 2.952-1.5 4.474l-.1-.271-2.1-6.25c-.1-.3-.2-.6-.3-.894-.03-.083-.013-.108.074-.114.211-.013.422-.032.632-.054s.3-.114.308-.282a.267.267 0 0 0-.3-.3c-.459.02-.918.048-1.377.071a4.6 4.6 0 0 1-.914-.01A6.929 6.929 0 0 1 6.171.975zm-4.843 9.459a6.934 6.934 0 0 1 .059-5.507l3.305 9.062a6.693 6.693 0 0 1-3.364-3.554zm4.507 3.889q1.006-2.9 2-5.806c.009-.028.022-.056.047-.121l.43 1.166q.853 2.34 1.711 4.679c.041.112-.012.117-.085.141a7.083 7.083 0 0 1-1.882.342 7.179 7.179 0 0 1-2.115-.232c-.091-.023-.151-.037-.106-.168zm3.307 8.818a.853.853 0 0 1-.852.852h-.719a.853.853 0 0 1-.852-.852v-.719a.853.853 0 0 1 .852-.852h.719a.853.853 0 0 1 .852.852zm17.041 0a.854.854 0 0 1-.853.852h-.719a.853.853 0 0 1-.852-.852v-.719a.853.853 0 0 1 .852-.852h.719a.854.854 0 0 1 .853.852z',
      fill: '#ccaf83' })
  );
}), _defineProperty(_$actualSize$archiv, 'zoom-in', function zoomIn(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 18 18' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M17,16.3l-5.6-5.6c1-1.1,1.6-2.6,1.6-4.2c0-1.7-0.7-3.4-1.9-4.6C9.9,0.7,8.2,0,6.5,0C2.9,0,0,2.9,0,6.5S2.9,13,6.5,13 c1.6,0,3.1-0.6,4.2-1.6l5.6,5.6L17,16.3z M2.6,10.4C2.6,10.4,2.6,10.4,2.6,10.4c-2.1-2.2-2.1-5.6,0-7.8C3.6,1.6,5,1,6.5,1 C8,1,9.4,1.6,10.4,2.6c2.1,2.2,2.1,5.6,0,7.8C8.2,12.5,4.8,12.5,2.6,10.4z' }),
      _react2.default.createElement('polygon', { points: '7,3 6,3 6,6 3,6 3,7 6,7 6,10 7,10 7,7 10,7 10,6 7,6  ' })
    )
  );
}), _defineProperty(_$actualSize$archiv, 'zoom-out', function zoomOut(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 18 18' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M17,16.3l-5.6-5.6c1-1.1,1.6-2.6,1.6-4.2c0-1.7-0.7-3.4-1.9-4.6C9.9,0.7,8.2,0,6.5,0C2.9,0,0,2.9,0,6.5S2.9,13,6.5,13 c1.6,0,3.1-0.6,4.2-1.6l5.6,5.6L17,16.3z M2.6,10.4C2.6,10.4,2.6,10.4,2.6,10.4c-2.1-2.2-2.1-5.6,0-7.8C3.6,1.6,5,1,6.5,1 C8,1,9.4,1.6,10.4,2.6c2.1,2.2,2.1,5.6,0,7.8C8.2,12.5,4.8,12.5,2.6,10.4z' }),
      _react2.default.createElement('rect', { x: '3', y: '6', width: '7', height: '1' })
    )
  );
}), _defineProperty(_$actualSize$archiv, 'exclamation', function exclamation(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 3 12' }, props),
    _react2.default.createElement('path', {
      d: 'M.55,0H2.39C2.94,0,3,.3,3,.48V.84L2.63,7.4c-.06.48-.3.6-.67.6H1C.67,8,.43,7.88.37,7.4L0,.84V.48C0,.3.06,0,.55,0Z' }),
    _react2.default.createElement('path', { d: 'M1.5,12A1.5,1.5,0,1,1,3,10.5H3A1.5,1.5,0,0,1,1.55,12Z' })
  );
}), _$actualSize$archiv);